import { useEffect, useState } from "react";
import Select from "react-select";
// import DateRangePicker from 'react-date-range';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";
import {
  Col,
  Offcanvas,
  Row,
  Tab,
  Nav,
  Dropdown,
  Modal,
  Table,
  Button,
} from "react-bootstrap";
import imgs from "../../Utils/assets/img/company-concept.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FaTrash } from "react-icons/fa6";
import {
  faAddressBook,
  faAngleDown,
  faBriefcase,
  faBuildingColumns,
  faClock,
  faEnvelope,
  faAngleUp,
  faFileLines,
  faFlag,
  faLandmarkDome,
  faLocationCrosshairs,
  faLocationDot,
  faMapLocationDot,
  faMessage,
  faPenFancy,
  faPhone,
  faXmark,
  faStar,
  faStickyNote,
  faList,
  faUser,
  faPhoneVolume,
  faEllipsisVertical,
  faTimes,
  faDollarSign,
  faUserLock,
  faPlus,
} from "@fortawesome/free-solid-svg-icons";
import {
  FaFacebook,
  FaLinkedin,
  FaWhatsapp,
  FaTwitterSquare,
  FaInstagramSquare,
  FaStickyNote,
} from "react-icons/fa";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";

import {
  GetRequest,
  PutRequest,
  PostRequest,
  DeleteRequest,
} from "../../Utils/hooks/ApiHandler";
import { baseURL } from "../../Utils/constants/constant";
import {
  formatDate,
  formatDateInAlphabeticalMonth,
  formatTime,
  formatToINR,
  maskContactNumber,
  putCommaInLeadsValue,
  stripHtml,
} from "../../Utils/helpers/commonhelper";
import { toast } from "sonner";
import DeleteModal from "../DeleteModal";
import { DetailsSkeleton } from "../../Utils/skeletonLoader/DetailsSkeleton";
// import { CloudLightning } from "lucide-react";
import { WhatsappModal } from "../../pages/WhatsappModal";
import { CreateLead } from './../Leads/CreateLead';
// import EditCompanyOffcanvas from "../../pages/EditCompanyOffcanvas";
// import { useGetRequest } from "../../Utils/hooks/QueryHandler";
import DocumentsList from "./DocumentsList";
import { CreateDeal } from "../deals/CreateDeal";
import { UpdateDeal } from "../deals/UpdateDeal";
import ReactQuill from "react-quill";
import { DealDetails } from "../deals/DealDetails";
import { LeadsDetails } from "./leads/LeadsDetails";
import nodata from "../../Utils/assets/img/leads_no_data_found.png"
import { useGetRequest } from "../../Utils/hooks/QueryHandler"
import { ContactActivity } from "../../pages/ContactActivity";
import TwilioIntegrationForm from "../ivr/TwilioIntegrationForm";
import GlobalCallModal from "../ivr/GlobalCallModal";
import { ContactForm } from "../education/Contacts/ContactModule/ContactForm.jsx";
import { ContactDetails } from "./Contacts/ContactDetails.jsx";
import { UnauthViewModal } from "../../pages/UnauthViewModal.jsx";
import { UnauthorizedTableState } from "../../pages/UnauthorizedTableState.jsx";
// import EmailSettingsModal from "../EmailIntegrationModal/EmailSettingsModal";
import { checkTwilioIntegration } from './../../Utils/helpers/commonhelper';
import DyanmicCallLog from './../ivr/DynamicCallLog';
import { getCountries } from "../../Utils/hooks/location.jsx";
function forceInline(html) {
  const blockTags = ["div", "p", "h1", "h2", "h3", "h4", "h5", "h6"];

  let processed = html;
  blockTags.forEach((tag) => {
    const regex = new RegExp(`<${tag}`, "gi");
    processed = processed.replace(regex, `<${tag} style="display:inline"`);
  });

  return processed;
}

export const CompanyDetails = ({
  show,
  id,
  allCompanies,
  onCanvasClose,
  setShowCompanyDetails,
  onlyDetails
}) => {
  // Add these to your existing state declarations
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [globalDiller, setGlobalDiller] = useState(false);
  const [showtwilioModal, setShowTwilioModal] = useState(false);
  const [callLogOpen, setCallLogOpen] = useState(false);
  const [showContactCanvas, setContactCanvas] = useState(false);
  const [noteToDelete, setNoteToDelete] = useState(null);
  const [expandedNoteId, setExpandedNoteId] = useState(null);
  const [activeTab, setActiveTab] = useState("Communications"); // Track active tab
  const [expanded, setExpanded] = useState(false);
  const [isNotesOpen, setIsNotesOpen] = useState(true);
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [showDealDetails, setShowDealDetails] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [selectedLeadId, setSelectedLeadId] = useState(null);
  const [showLeadDetails, setShowLeadDetails] = useState(false);
  // const [ownerDetails, setOwnerDetails] = useState([]);
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [findData, setFindData] = useState(false);
  const [isCloneClicked, setIsCloneClicked] = useState(false);
  const [showAddDealOffcanvas, setShowAddDealOffcanvas] = useState(false);
  const [contactDetails, setContactDetails] = useState({});
  // delete leadId
  const [showLeadDeleteModal, setShowLeadDeleteModal] = useState(false);
  const [associatedDeals, setAssociatedDeals] = useState(false);
  const [showAddLeadsOffcanvas, setShowAddLeadsOffcanvas] = useState(false);
  // stage id for deal set it null
  const [selectedStageId, setSelectedStageId] = useState(null);
  const [selectedDealId, setSelectedDealId] = useState(null);
  const [openRow, setOpenRow] = useState(null);

  // leads and deals status
  const [dealStatus, setDealStatus] = useState({});

  const [leadsStatus, setLeadsStatus] = useState({});

  // set deals card data
  const [dealsCardData, setDealsCardData] = useState([]);

  // deal data set
  const [deals, setDeals] = useState([]);
  const [contactDeals, setContactDeals] = useState([]);
  // lead and deal id for edit and delete use
  const [editLeadId, setEditLeadId] = useState(null);
  const [editDealId, setEditDealId] = useState(null);
  // open delete modal to delete lead
  const [deleteLeadId, setDeleteLeadId] = useState(null);
  //open delete mode to delete deal
  const [deleteDealId, setDeleteDealId] = useState(null);
  // open delete modal to delete deal
  const [showDealDeleteModal, setShowDealDeleteModal] = useState(false);
  const [leads, setLeads] = useState([]);
  const [onleadClied, setOnclickedLead] = useState(false);
  // parsed data states
  const [parsedUserPhone, setParsedUserPhone] = useState([]);
  const [showAllPhoneNumbers, setShowAllPhoneNumbers] = useState(false);
  //
  const [parsedUserEmail, setParsedUserEmail] = useState([]);
  const [showAllEmails, setShowAllEmails] = useState(false);
  const [parsedTimezone, setParsedTimezone] = useState({});
  const [loadings, setLoadings] = useState(false);
  // update or edit deal offcanvas state
  const [showUpdateDealOffcanvas, setShowUpdateDealOffcanvas] = useState(false);
  const [isCheckingTwilio, setIsCheckingTwilio] = useState(false);
  let idx = 1;
  const [integrationStatus, setIntegrationStatus] = useState({
    whatsapp: "not_checked", // 'not_checked', 'success', 'fail'
    sms: "not_checked",
    email: "not_checked",
  });

  // Add these to your existing state declarations
  const [showMessageModal, setShowMessageModal] = useState({
    whatsapp: false,
    sms: false,
    email: false,
  });
  const [messageData, setMessageData] = useState({
    subject: "",
    body: "",
    file: null,
    notes: "",
  });
  const [showContactDetails, setShowContactDetails] = useState(false);
  const [selectedContactId, setSelectedContactId] = useState(null);

  const [whatsappKey, setWhatsappKey] = useState(null);
  const [smsKey, setSmsKey] = useState(null);
  const [apiLoading, setApiLoading] = useState({
    whatsapp: false,
    sms: false,
    email: false,
  });
  const [apiError, setApiError] = useState({
    whatsapp: null,
    sms: null,
    email: null,
  });
  const [whatsappModalOpen, setWhatsAppModalOpen] = useState(false);
  const [notes, setNotes] = useState([]);
  const [notesContent, setNotesContent] = useState("");
  const [editingNoteId, setEditingNoteId] = useState(null);
  const [isNotesLoading, setIsNotesLoading] = useState(false);
  const [notesError, setNotesError] = useState(null);
  const [companyData, setCompanyData] = useState(null);
  console.log("companyData", companyData)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [shows, setShows] = useState(false);
  const [targets, setTargets] = useState(null);
  const navigate = useNavigate();
  const [customer, setCustomer] = useLocalStorageState("customer");
  const [companyLeads, setCompanyLeads] = useState([]);
  const [nextPrevious, setNextPrevious] = useState(
    !onlyDetails && allCompanies?.findIndex((obj) => obj.id == id)
  );

  // company id common variable
  const companyId = allCompanies?.[nextPrevious]?.id || id;

  const [country, setCountries] = useState([{ countryName: "", countryId: 0 }])
  // Email module specific state
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailRecipients, setEmailRecipients] = useState([]);
  const [currentEmailInput, setCurrentEmailInput] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [templates, setTemplates] = useState([]);
  const [templatesLoading, setTemplatesLoading] = useState(false);
  const [emailSending, setEmailSending] = useState(false);
  const [documents, setDocuments] = useState([])
  const [documentToDelete, setDocumentToDelete] = useState(null)
  const [deleteDocument, setDeleteDocument] = useState(false)

  const [showIntegrationModal, setShowIntegrationModal] = useState({
    whatsapp: false,
    sms: false,
    email: false,
  });

  const [integrationError, setIntegrationError] = useState({
    whatsapp: null,
    sms: null,
    email: null,
  });
  const [smtpDetails, setSmtpDetails] = useState(null);
  const [integrationLoading, setIntegrationLoading] = useState(false);
  const customerId = customer?.customer_details?.customer_id;
  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = {
    authentication: rf,
    Authorization: token,
  };

  const nextCompany = () => {
    setNextPrevious(nextPrevious + 1);
    setAssociatedDeals(false);
  };

  const previousCompany = () => {
    setNextPrevious(nextPrevious - 1);
    setAssociatedDeals(false);
  };

  const extras = { customer, setCustomer, rf, navigate };

  // permission setup for company
  const permission = customer.customer_details?.permission
  // company permissions while creating contact
  const companyPermission = permission?.filter(c => c.module_name === "company")
  const user_type = Number(customer.customer_details?.user_type)
  const leadSourcePermission = permission?.filter(
    (c) => c.module_name === "setting",
  )
  const masterGrant = {
    isCreate:
      user_type !== 1
        ? Boolean(
          Number(
            leadSourcePermission?.find((c) => c.feature_name === "master")
              ?.create,
          ),
        )
        : true,
  }
  const companyGrants = {
    isView: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "company")?.delete)) : true,
    isImport: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "import")?.is_action)) : true,
    isExport: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "export")?.is_action)) : true,
  }
  const companyDocGrant = {
    isView: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "document")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "document")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "document")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "document")?.delete)) : true,
  }
  const companyNoteGrant = {
    isView: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "notes")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "notes")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "notes")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "notes")?.delete)) : true,
  }
  const companyActivityGrant = {
    isView: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "activity")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "activity")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "activity")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(companyPermission?.find(c => c.feature_name === "activity")?.delete)) : true,
  }
  // contact permissions
  const contactPermssion = permission?.filter(c => c.module_name === "contact")
  const contactGrants = {
    isView: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(contactPermssion?.find(c => c.feature_name === "contact")?.create)) : true,
  }

  // permission for lead and deal
  const leadPermission = permission?.filter(c => c.module_name === "leads")
  const dealPermission = permission?.filter(c => c.module_name === "deals")

  const leadGrant = {
    isView: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(leadPermission?.find(c => c.feature_name === "leads")?.delete)) : true,
  }
  const dealGrant = {
    isView: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.view)) : true,
    isCreate: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.create)) : true,
    isEdit: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.edit)) : true,
    isDelete: user_type !== 1 ? Boolean(Number(dealPermission?.find(c => c.feature_name === "deals")?.delete)) : true,
  }

  const fetchNotes = async () => {
    setIsNotesLoading(true);
    setNotesError(null);

    try {
      const response = await GetRequest(
        `company/fetchNotes/${companyId}/${customerId}`,
        { headers },
        extras
      );

      if (response.data) {
        setNotes(response.data);
      } else {
        setNotesError("Failed to load notes");
      }
    } catch (error) {
      setNotesError(error.message || "Error loading notes");
    } finally {
      setIsNotesLoading(false);
    }
  };

  // Fetch countries when component mounts
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const data = await getCountries()
        if (data) {
          setCountries(
            data.map((c) => ({
              countryName: c.name,
              countryId: c.id,
            })),
          )
        }
      } catch (err) {
        return
      }
    }
    if (show) {
      fetchCountries()
    }
  }, [])

  // by ansi
  const fetchAllDeals = async () => {
    try {
      setLoading(true);
      const res = await GetRequest(
        `company/fetchAllDealsOfCompany/${companyId}/${customerId}`,
        { headers },
        { extras }
      );

      setContactDeals(res.data);
      setDealsCardData(res.data);
      setDeals([]);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchDealsByStatus = async () => {
    try {
      const endpoint =
        dealStatus === "won"
          ? `/company/fetchAllDealsOfCompanyBasedOnStatus/${companyId}/${customerId}/won`
          : dealStatus === "lost"
            ? `/company/fetchAllDealsOfCompanyBasedOnStatus/${companyId}/${customerId}/lost`
            : dealStatus === "unqualified"
              ? `/company/fetchAllDealsOfCompanyBasedOnStatus/${companyId}/${customerId}/unqualified`
              : "";
      const res = await GetRequest(endpoint, { headers }, { extras });

      // setDealStatus(res.data)
      setDeals(res?.data);
      // setContactDeals([])
      // setLoading(false)
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDealsByStatus();
  }, [dealStatus]);
  // Documents

  const apiUrl = `company/fetchDocuments/${customerId}/${companyId}`

  const {
    data: documentData,
    errors,
    refetch: fetchDocument,
    isError,
    isLoading,
  } = useGetRequest(apiUrl, "getDocument", headers, extras)

  // Update documents
  useEffect(() => {
    if (documentData?.status === "success") {
      setDocuments(documentData?.data)
    } else if (isError) {
      console.error("Error fetching documents:", errors)
    }
  }, [documentData, isError, errors])

  const handleDeleteConfirm = async () => {
    setLoading(true)
    try {
      const response = await DeleteRequest(
        `lead/deleteLead/${deleteLeadId}/${customer?.customer_details?.id}`,
        { headers },
        extras
      );

      if (response?.status === "success") {
        toast.success("Lead deleted successfully");
        await fetchCompanyDetails();
        setLoading(false)
      } else {
        setLoading(false)
        toast.error(response?.message || "Failed to delete lead");
      }
    } catch (error) {
      setLoading(false)
      toast.error("An error occurred while deleting lead");
    } finally {
      setLoading(false)
      setShowLeadDeleteModal(false);
      setDeleteLeadId(null);
    }
  };

  // function to delete deal

  const handleDeleteDealConfirm = async () => {
    setLoading(true)
    try {
      const response = await DeleteRequest(
        `deals/deleteDeal/${deleteDealId}/${customer.customer_details?.id}`,
        { headers },
        extras
      );

      if (response?.status === "success") {
        toast.success(response.message);
        setLoading(false)
        await fetchAllDeals();
      } else {
        setLoading(false)
        toast.error(response?.message || "Failed to delete Deal");
      }
    } catch (error) {
      setLoading(false)
      toast.error("An error occurred while deleting deal");
    } finally {
      setLoading(false)
      setShowDealDeleteModal(false);
      setDeleteDealId(null);
    }
  };

  const handleReassingCancle = () => {
    setShowReassignModal(false);
    setSelectedUser(null);
  };

  const handleConfirmedDelete = async () => {
    setLoading(true)
    try {
      const item = documents.find((doc) => doc.id === documentToDelete)

      if (!item) return toast.error("no record find to delete")

      const res = await DeleteRequest(
        `/Company/DeleteDocuments/${companyId}/${documentToDelete}`,
        { headers },
        extras,
      )

      if (res.status !== "success" || res.status === "fail") {
        setLoading(false)
        return toast.error(res.message || "failed to delete document")
      }

      if (res.status === "success") {
        toast.success(res.message || "document deleted successfully")
        setDocuments((prevDocs) =>
          prevDocs.filter((doc) => doc.id !== documentToDelete),
        )
        setLoading(false)
        await fetchDocument()
        setDeleteDocument(false)
      }
    } catch (error) {
      console.error("Delete error", error)
      setLoading(false)
    } finally {
      setShowDeleteModal(false)
      setLoading(false)
      setDocumentToDelete(null)
    }
  }


  useEffect(() => {
    if (findData) {
      setShowCompanyDetails(false);
      setFindData(false);
    }
  }, [findData]);

  const handleCloneClicked = () => {
    setShowOffcanvas(true);
    setIsCloneClicked(true);
  };

  // const company_data = allCompanies?.find((company) => allCompanies[nextPrevious].id === company.id);
  const handleDeleteCompany = async (id) => {
    setLoading(true)
    try {
      const res = await DeleteRequest(
        `company/deleteCompany/${id}`,
        { headers },
        extras
      );

      // Always close the popup
      setConfirmDeleteId(null);
      onCanvasClose()

      if (res?.success || res?.status === "success") {
        setLoading(false)
        toast.success(res.message || "Deleted successfully"); // Refresh the company list
      } else {
        setLoading(false)
        toast.error(res?.message || "Company associated to contact");
      }
    } catch (err) {
      // Close popup even on error
      setConfirmDeleteId(null);
      setLoading(false)
      toast.error(err.message || "Delete error");
    }
  };

  const fetchLeads_status = async () => {
    setLeads([]);

    try {
      const endpoint =
        leadsStatus === "won"
          ? `company/fetchWonLeads/${customerId}/${companyId}`
          : leadsStatus === "lost"
            ? `company/fetchLostLeads/${customerId}/${companyId}`
            : leadsStatus === "unqualified"
              ? `company/fetchUnqualifiedLeads/${customerId}/${companyId}`
              : "";
      setLoading(true); // Set loading to true when starting
      const res = await GetRequest(endpoint, { headers }, extras);

      setLeads(res.data);
      setLoading(false); // Set loading to false when done
    } catch (err) {
      setLoading(false); // Ensure loading is false even on error
    }
  };

  useEffect(() => {
    fetchLeads_status();
  }, [leadsStatus]);

  useEffect(() => {
    if (show && companyId) {
      fetchCompanyDetails();
      fetchNotes();
    }
  }, [show, companyId, nextPrevious, onleadClied]);



  // Handle create/update note
  const handleSaveNote = async () => {
    if (!notesContent.trim()) {
      setNotesError("Please enter some notes before submitting");
      return;
    }

    setIsNotesLoading(true);
    setNotesError(null);
    try {
      setLoadings(true);
      let response;
      const noteData = {
        customer_id: customerId,
        company_id: companyId,
        notes: notesContent,
        // user_login_id: customer?.customer_details?.user_login_id;
        user_login_id: customer?.customer_details?.id,
      };

      if (editingNoteId) {
        // Update existing note
        response = await PutRequest(
          "company/updateNote",
          { ...noteData, note_id: editingNoteId },
          { headers },
          extras
        );
      } else {
        // Create new note
        response = await PostRequest(
          "company/createNote",
          noteData,
          false, // imgApi flag set to false
          { headers },
          extras
        );
      }

      if (response.data) {
        setLoadings(false);
        toast.success(
          `Note ${editingNoteId ? "updated" : "created"} successfully`
        );
        setNotesContent("");
        setEditingNoteId(null);
        fetchNotes(); // Refresh n9otes list
      } else {
        setNotesError(
          response.message ||
          `Failed to ${editingNoteId ? "update" : "create"} note`
        );
      }
    } catch (error) {
      setNotesError(error.message || "Error saving note");
    } finally {
      setLoadings(false)
      setIsNotesLoading(false);
    }
  };

  const handleEditNote = async (noteId) => {
    setIsNotesLoading(true);
    setNotesError(null);

    try {
      setLoadings(true)
      const response = await GetRequest(
        `company/getNotesById/${noteId}/${companyId}`,
        { headers },
        extras
      );

      if (response.data && response.data.length > 0) {
        const note = response.data[0]; // <-- yaha pe sahi note milega
        setNotesContent(note.notes); // editor me ye content jayega
        setEditingNoteId(noteId);
        setIsNotesOpen(false); // editor khol de
      } else {
        setNotesError("Failed to load note for editing");
      }
    } catch (error) {
      setNotesError(error.message || "Error loading note");
    } finally {
      setLoadings(false)
      setIsNotesLoading(false);
    }
  };

  const handleMessageInputChange = (e) => {
    const { name, value } = e.target;
    setMessageData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setMessageData((prev) => ({
      ...prev,
      file: e.target.files[0],
    }));
  };

  const handleBodyChange = (content, delta, source, editor) => {

    setMessageData((prev) => ({
      ...prev,
      body: content,
    }));
  };


  const handleSendMessage = async (type) => {
    // Implement your API call to send the message based on type (whatsapp/sms/email)
    // You can use messageData.subject, messageData.body, messageData.file, messageData.notes
    try {
      const formData = new FormData();
      formData.append("subject", messageData.subject);
      formData.append("body", messageData.body);
      formData.append("notes", messageData.notes);
      if (messageData.file) {
        formData.append("file", messageData.file);
      }
      formData.append("company_id", companyId);
      formData.append("customer_id", customerId);

      const payload = {
        subject: messageData.subject,
        body: messageData.body,
        notes: messageData.notes !== "" ? messageData.notes : "",
        file: messageData.file,
        customer_id: customer.customer_details?.customer_id,
        to_id: companyId,
        module_name: "company",
        user_login_id: customer.customer_details?.id,
      };
      let endpoint = "";
      if (type === "whatsapp") {
        endpoint = "whatsapp/sendMessage";
      } else if (type === "sms") {
        endpoint = "sms/sendMessage";
      } else if (type === "email") {
        endpoint = "common/sendMail";
      }
      const response = await PostRequest(
        endpoint,
        payload,
        true, // Set to true if sending files
        { headers },
        extras
      );
      if (response.status === "success") {
        toast.success(`Message sent successfully via ${type}`);
        setShowMessageModal((prev) => ({ ...prev, [type]: false }));
        setMessageData({
          subject: "",
          body: "",
          file: null,
          notes: "",
        });
      } else {
        toast.error(response.message || `Failed to send ${type} message`);
      }
    } catch (error) {
      toast.error(error.message || `Error sending ${type} message`);
    }
  };

  // Fetch email templates
  const fetchTemplates = async () => {
    setTemplatesLoading(true);
    try {
      const response = await GetRequest(
        `common/fetchEmailTemplates`,
        { headers },
        extras
      );

      if (response.status === "success" && response.data) {
        setTemplates(response.data);
      }
    } catch (error) {
      console.error("Error fetching templates:", error);
    } finally {
      setTemplatesLoading(false);
    }
  };

  // Handle template selection
  const handleTemplateSelect = async (templateId, templateName) => {
    if (!templateId) {
      setSelectedTemplate("");
      return;
    }

    setSelectedTemplate(templateName);

    try {
      const response = await GetRequest(
        `common/getEmailTemplate/${templateId}/${templateId}`,
        { headers },
        extras
      );

      if (response.status === "success" && response.data) {
        setMessageData((prev) => ({
          ...prev,
          subject: response.data.subject || "",
          body: response.data.body || "",
        }));
      }
    } catch (error) {
      toast.error("Error loading template");
    }
  };
  const handleEmailInputKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addEmailTag();
    }
  };

  const addEmailTag = () => {
    const email = currentEmailInput.trim();
    if (email && isValidEmail(email) && !emailRecipients.includes(email)) {
      setEmailRecipients((prev) => [...prev, email]);
      setCurrentEmailInput("");
    } else if (!isValidEmail(email)) {
      toast.error("Please enter a valid email address");
    }
  };
  const removeEmailTag = (emailToRemove) => {
    setEmailRecipients((prev) =>
      prev.filter((email) => email !== emailToRemove)
    );
  };

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSendEmail = async () => {
    if (emailRecipients.length === 0) {
      toast.error("Please add at least one email recipient");
      return;
    }

    if (!messageData.subject.trim()) {
      toast.error("Please enter email subject");
      return;
    }

    if (!messageData.body.trim()) {
      toast.error("Please enter email body");
      return;
    }
    setEmailSending(true);

    try {
      const payload = {
        customer_id: customerId,
        to_id: companyId,
        user_email: emailRecipients,
        subject: messageData.subject,
        body: messageData.body,
        module_name: "company",
        user_login_id: customer?.customer_details?.id,
      };

      const response = await PostRequest(
        "common/sendMail",
        payload,
        true, // For file upload
        { headers },
        extras
      );
      if (response.status === "success") {
        toast.success("Email sent successfully");
        handleCloseEmailModal();
      } else {
        toast.error(response.message || "Failed to send email");
      }
    } catch (error) {
      toast.error(error.message || "Error sending email");
    } finally {
      setEmailSending(false);
    }
  };

  const handleCloseEmailModal = () => {
    setMessageData({
      subject: "",
      body: "",
      file: null,
      notes: "",
    });
    setEmailRecipients([]);
    setCurrentEmailInput("");
    setSelectedTemplate("");
    setShowEmailModal(false);
  };

  const handleIntegrationModalClose = () => {
    setShowIntegrationModal(false);
  };
  // Handle delete note
  const handleDeleteNote = async (noteId) => {
    setIsNotesLoading(true);
    setNotesError(null);
    setLoading(true)
    try {
      const response = await DeleteRequest(
        `company/deleteNotes/${companyId}/${noteId.id}/${customer?.customer_details?.id}`,
        { headers },
        extras
      );

      if (response.status == "success") {
        toast.success("Note deleted successfully");
        fetchNotes(); // Refresh notes list
        setShowDeleteModal(false);
        setLoading(false)
      } else {
        setNotesError(response.message || "Failed to delete note");
        setLoading(false)
      }
    } catch (error) {
      setNotesError(error.message || "Error deleting note");
      setLoading(false)
    } finally {
      setIsNotesLoading(false);
      setLoading(false)
    }
  };

  // Trigger delete modal
  const onDelete = (id) => {
    setDocumentToDelete(id)
    setShowDeleteModal(true)
    setDeleteDocument(true)
  }
  const fetchCompanyDetails = async () => {
    setOnclickedLead(false);

    setLeads([]);
    if (!customerId) return;

    setLoading(true);
    setError(null);

    try {
      const res = await GetRequest(
        `company/CompanyDetails/${customerId}/${companyId}`,
        { headers },
        extras
      );
      if (res.data) {
        setCompanyData(res.data);
        setContactDetails(res.data);
        setLeads([]);
        setCompanyLeads(res.data);
        const parsedPhoneData = res.data[0]?.user_phone
          ? JSON.parse(res.data[0]?.user_phone)
          : null;
        parsedPhoneData && setParsedUserPhone(parsedPhoneData);
        // parsed for email
        const parsedEmailData = res.data[0]?.user_email
          ? JSON.parse(res.data[0]?.user_email)
          : null;
        parsedEmailData && setParsedUserEmail(parsedEmailData);

        // parsed time zone
        const timezone = res.data[0]?.timezone
          ? JSON.parse(res.data[0]?.timezone)
          : null;
        timezone && setParsedTimezone(timezone);
      } else {
        setError("No company details found");
      }
    } catch (err) {
      setError(err.message || "Failed to fetch company details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanyDetails();
  }, [show, customerId, nextPrevious, activeTab]);

  const handleClick = (event) => {
    setShows(!shows);
    setTargets(event.target);
  };

  const handleClose = () => {
    setShows(false);
    setShowDealDetails(false);
    setShowLeadDetails(false)
  };
  // Helper functions to parse JSON data
  const parseUserPhone = (phoneData) => {
    try {
      if (typeof phoneData === "string") {
        const parsed = JSON.parse(phoneData);
        return Array.isArray(parsed) ? parsed[0] : parsed;
      }
      return phoneData;
    } catch {
      return null;
    }
  };

  const parseUserEmail = (emailData) => {
    try {
      if (typeof emailData === "string") {
        const parsed = JSON.parse(emailData);
        return Array.isArray(parsed) ? parsed[0] : parsed;
      }
      return emailData;
    } catch {
      return null;
    }
  };

  // Render star rating
  const renderStarRating = (rating) => {
    const stars = [];
    const numRating = Number.parseInt(rating) || 0;
    for (let i = 0; i < 5; i++) {
      stars.push(
        <FontAwesomeIcon
          key={i}
          icon={faStar}
          style={{
            fontSize: "12px",
            color: i < numRating ? "#dfd113" : "#ddd",
          }}
        />
      );
    }
    return stars;
  };

  if (!companyData) {
    return null;
  }


  const customSelectStyles = {
    control: (base, state) => ({
        ...base,
        marginTop : '10px',
        minHeight: 38,
        fontSize: 13,
        padding: "0 4px",
        boxShadow: "none",
        border: state.isFocused ? "1px solid #2684FF" : "1px solid #d1d5db",
        "&:hover": {
          borderColor: "#60a5fa",
        },
      }),
      valueContainer: (base) => ({
        ...base,
        padding: "0 4px",
      }),
      input: (base) => ({
        ...base,
        padding: "2px 0",
        margin: 0,
      }),
      placeholder: (base) => ({
        ...base,
        fontSize: 13,
      }),
      singleValue: (base) => ({
        ...base,
        fontSize: 13,
      }),
      indicatorsContainer: (base) => ({
        ...base,
        height: 34,
        padding: "0 3px",
      }),
      dropdownIndicator: (base) => ({
        ...base,
        padding: "4px",
      }),
      option: (base) => ({
        ...base,
        fontSize: 13,
        padding: "6px 10px",
      }),
      menuList: (base) => ({
        ...base,
        maxHeight: 200,
        overflowY: "auto",
        scrollBehavior: "smooth",
        "::-webkit-scrollbar": {
          width: "8px",
        },
        "::-webkit-scrollbar-track": {
          background: "#f1f1f1",
          borderRadius: "4px",
        },
        "::-webkit-scrollbar-thumb": {
          background: "#c9c9c9",
          borderRadius: "4px",
        },
        "::-webkit-scrollbar-thumb:hover": {
          background: "#888",
        },
      }),
      menuPortal: (base) => ({
        ...base,
        zIndex: 9999,
      }),
      menu: (base) => ({
        ...base,
        zIndex: 9999,
      }),
      multiValue: (base) => ({
        ...base,
        backgroundColor: "#3b82f6",
        color: "white",
        fontSize: 12,
      }),
      multiValueLabel: (base) => ({
        ...base,
        color: "white",
        fontWeight: 500,
      }),
      multiValueRemove: (base) => ({
        ...base,
        color: "white",
        ":hover": {
          backgroundColor: "#ef4444",
          color: "white",
        },
      }),
    };

  const userPhone = parseUserPhone(companyData[0].user_phone);
  const userEmail = parseUserEmail(companyData[0].user_email);
  const company_timezone = JSON.parse(companyData[0].timezone);
  const fetchWhatsappKey = async () => {
    setApiLoading((prev) => ({ ...prev, whatsapp: true }));
    setApiError((prev) => ({ ...prev, whatsapp: null }));

    try {
      const response = await GetRequest(
        `common/fetchWhatsappKey/${customerId}/company`,
        { headers },
        extras
      );

      if (response.status === "success") {
        setWhatsappKey(response.data);
        setWhatsAppModalOpen(true);
        // setShowMessageModal({ whatsapp: true, sms: false, email: false });
      } else {
        setShowIntegrationModal((prev) => ({ ...prev, whatsapp: true }));
        setIntegrationError((prev) => ({
          ...prev,
          whatsapp:
            "WhatsApp integration is not configured. Please set up WhatsApp Business API.",
        }));
      }
    } catch (error) {
      setShowIntegrationModal((prev) => ({ ...prev, whatsapp: true }));
      setIntegrationError((prev) => ({
        ...prev,
        whatsapp: "Failed to check WhatsApp integration. Please try again.",
      }));
    } finally {
      setApiLoading((prev) => ({ ...prev, whatsapp: false }));
    }
  };

  const fetchSmsKey = async () => {
    setApiLoading((prev) => ({ ...prev, sms: true }));
    setApiError((prev) => ({ ...prev, sms: null }));


    try {
      const response = await GetRequest(
        `common/fetchSmsKey/${customerId}/company`,
        { headers },
        extras
      );

      if (response.status === "success") {
        setSmsKey(response.data);
        setShowMessageModal({ whatsapp: false, sms: true, email: false });
      } else {
        setShowIntegrationModal((prev) => ({ ...prev, sms: true }));
        setIntegrationError((prev) => ({
          ...prev,
          sms: "SMS integration is not configured. Please set up SMS gateway.",
        }));
      }
    } catch (error) {
      setShowIntegrationModal((prev) => ({ ...prev, sms: true }));
      setIntegrationError((prev) => ({
        ...prev,
        sms: "Failed to check SMS integration. Please try again.",
      }));
    } finally {
      setApiLoading((prev) => ({ ...prev, sms: false }));
    }
  };

  const checkSmtpIntegration = async () => {
    setIntegrationLoading(true);
    setApiError((prev) => ({ ...prev, email: null }));

    try {
      const response = await GetRequest(
        `common/fetchSMTPDetails/${customerId}/company`,
        { headers },
        extras
      );

      if (response.status === "success" && response.data) {
        setSmtpDetails(response.data);
        fetchTemplates();
        setShowEmailModal(true);
      } else {
        setShowIntegrationModal((prev) => ({ ...prev, email: true }));
        setIntegrationError((prev) => ({
          ...prev,
          email:
            "Email integration is not configured. Please set up SMTP settings.",
        }));
      }
    } catch (error) {
      setShowIntegrationModal((prev) => ({ ...prev, email: true }));
      setIntegrationError((prev) => ({
        ...prev,
        email: "Failed to check email integration. Please try again.",
      }));
    } finally {
      setIntegrationLoading(false);
    }
  };
  const fetchSmtpDetails = async () => {
    setApiLoading((prev) => ({ ...prev, email: true }));

    try {
      const response = await GetRequest(
        `common/ fetchSMTPDetails / ${customerId} / company`,
        { headers },
        extras
      );

      // Modified condition to only check response.status
      if (response.status === "success") {
        setSmtpDetails(response.data); // Even if data is null
        setShowMessageModal({ whatsapp: false, sms: false, email: true });
      } else {
        setShowIntegrationModal({ whatsapp: false, sms: false, email: true });
      }
    } catch (error) {
      setShowIntegrationModal({ whatsapp: false, sms: false, email: true });
    } finally {
      setApiLoading((prev) => ({ ...prev, email: false }));
    }
  };
  const handleDealDetailPage = (val) => {
    setSelectedDealId(val?.id);
    setShowDealDetails(true);
  };



  const hideShow = (contents) => {
    const charLimit = 84; // Change this to any limit you want
    const isTruncatedss = contents.length > charLimit;
    const previews = contents.slice(0, charLimit);

    return (
      <>
        {expanded || !isTruncatedss ? contents : previews + "..."}
        {isTruncatedss && (
          <span
            onClick={() => setExpanded(!expanded)}
            style={{ color: "blue", cursor: "pointer", marginLeft: "3px" }}
          >
            {expanded ? "Less" : " More"}
          </span>
        )}
      </>
    );
  };

  const getRandomColor = (seed) => {
    const colors = [
      "#eaffbc",
      "#c8fff3",
      "#dff9ff",
      "#aecbfa",
      "#d5e4ff",
      "#fdcfe8",
      "#ffd6d2",
    ];

    // Use a hash from the seed (e.g., contact ID) to get consistent color
    let index = 0;
    for (let i = 0; i < seed.length; i++) {
      index += seed.charCodeAt(i);
    }

    return colors[index % colors.length];
  };

  const handleReassignTask = async () => {
    setShowReassignModal(true);

    const res = await GetRequest(
      `users/users/fetchUserAsOwner/${customer.customer_details.customer_id}`,
      { headers },
      { customer, setCustomer, rf: headers.authentication, navigate }
    );
    if (res?.status === "success") {
      // React Select format: { value, label }
      const options = res.data.map((user) => ({
        value: user.id,
        label: user.full_name,
      }));
      setUsers(options);
    }
  };

  const handleSubmit = async () => {
    const payload = {
      customer_id: customerId,
      owner_id: selectedUser.value,
      company_id: allCompanies[nextPrevious].id,
    };

    const res = await PutRequest(
      `/company/reassign/
  `,
      payload,
      { headers },
      extras
    );
    if (res.status === "success") {
      toast.success(res.message);
      setShowReassignModal(false);
      setShowCompanyDetails(false);
    }
  };

  // function to close edit deals canvas
  const handleUpdateDealClose = () => {
    setShowUpdateDealOffcanvas(false);
    setSelectedStageId(null);
  };

  const handleOnLeadClick = (val) => {
    setShowLeadDetails(true);
    setSelectedLeadId(val?.id);
  };


  // for calling
  const handleGlobalCallChange = () => {
    setGlobalDiller(false);
  };

  const checkTwilio = async () => {
    if (isCheckingTwilio) return;
    setIsCheckingTwilio(true);
    try {
      const res = await checkTwilioIntegration(customerId, headers, extras)
      if (res.status === "fail" || res.success === false) {
        setShowTwilioModal(true);
      }
      if (res.status === "success") {
        setGlobalDiller(true);
      }

    } catch (error) {
      console.error(error)
    } finally {
      setIsCheckingTwilio(false);
    }
  }

  return (
    <>
      <div className="d-flex w-100">
        <Offcanvas
          className="w-100"
          id="contactDetailsOffcanvas"
          placement="end"
          backdrop="static"
          show={show}
          onHide={onCanvasClose}
          style={{ padding: "10px" }}
        >
          <Offcanvas.Body className="pt-0 pb-0">
            {loading ? (
              <DetailsSkeleton />
            ) : (

              <div
                className="d-flex align-items-center justify-content-between fs-13"
                style={
                  nextPrevious == "0"
                    ? { padding: "2px 0px 13px", color: "#0081d7" }
                    : { cursor: "pointer", padding: "2px 0px 13px" }
                }
              >
                {onlyDetails && <p></p>}
                {
                  !onlyDetails &&
                  <div className="d-flex align-items-center gap-2">
                    <p
                      className="mb-0 btn-light btn d-flex align-items-center"
                      onClick={previousCompany}
                      style={
                        nextPrevious == "0"
                          ? {
                            pointerEvents: "none",
                            color: "#969696",
                            cursor: "no-drop",
                            height: "30px",
                            fontWeight: 300,
                            borderRadius: 2,
                            fontSize: 13,
                            border: "1px solid lightblue",
                          }
                          : {
                            cursor: "pointer",
                            height: "30px",
                            fontSize: "13px",
                            borderRadius: 2,
                            fontWeight: 300,
                            border: "1px solid lightblue",
                          }
                      }
                      disabled={nextPrevious == allCompanies.length - 1}
                    >
                      <i className="me-1 bi bi-chevron-left" /> Prev
                    </p>

                    <p
                      className="mb-0 btn-light btn d-flex align-items-center"
                      onClick={nextCompany}
                      style={
                        nextPrevious == allCompanies.length - 1
                          ? {
                            pointerEvents: "none",
                            color: "#969696",
                            cursor: "no-drop",
                            height: "30px",
                            fontWeight: 300,
                            borderRadius: 2,
                            fontSize: 13,
                            border: "1px solid lightblue",
                          }
                          : {
                            cursor: "pointer",
                            height: "30px",
                            fontSize: "13px",
                            borderRadius: 2,
                            fontWeight: 300,
                            border: "1px solid lightblue",
                          }
                      }
                      disabled={nextPrevious == allCompanies.length - 1}
                    >
                      {" "}
                      Next <i className="ms-1 bi bi-chevron-right" />
                    </p>
                    <p
                      className="mb-0 mx-2 "
                      style={{ borderRight: "1px solid #c9c9c9", height: 29 }}
                    ></p>
                    <p
                      className="mb-0"
                      style={{
                        height: "30px",
                        display: "flex",
                        alignItems: "center",
                        color: "black",
                        fontSize: "19px",
                        fontWeight: 300,
                      }}
                    >
                      {" "}
                      Company Details{" "}
                    </p>
                  </div>
                }
                <div>
                  <div className="d-flex align-items-center gap-1">
                    <button
                      type="button"
                      className="btn btn-whatsapp p-2"
                      style={styles.listButtonsStyles}
                      onClick={fetchWhatsappKey}
                      disabled={apiLoading.whatsapp}
                    >
                      {apiLoading.whatsapp ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : integrationStatus.whatsapp === "success" ? (
                        <>
                          <FaWhatsapp style={{ fontSize: "13px" }} /> Configure
                        </>
                      ) : (
                        <>
                          {" "}
                          <FaWhatsapp
                            style={{ fontSize: "13px" }}
                          /> WhatsApp{" "}
                        </>
                      )}{" "}
                    </button>
                    <button
                      type="button"
                      className="btn btn-default btnss"
                      style={styles.listButtonsStyles}
                      onClick={() => {
                        // Pre-populate recipient if company has email
                        if (userEmail?.email) {
                          setEmailRecipients([userEmail.email]);
                        }
                        checkSmtpIntegration();
                      }}
                      disabled={integrationLoading}
                    >
                      {" "}
                      {integrationLoading ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : (
                        <>
                          <FontAwesomeIcon
                            icon={faEnvelope}
                            style={styles.iconStyles}
                          />{" "}
                          Email{" "}
                        </>
                      )}
                    </button>
                    <Dropdown
                      style={{ width: "55px" }}
                      className="dropdownsWithoutToggle"
                    >
                      <Dropdown.Toggle
                        variant="default"
                        style={styles.listButtonsStyless}
                        className="btn btn-default btnss"
                      >
                        <FontAwesomeIcon
                          icon={faPhone}
                          style={{
                            fontSize: "15px",
                            width: "20px",
                            color: "#ffff",
                          }}
                        />
                        Call
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        align="end"
                        style={{
                          width: "8rem",
                          boxShadow: "0 0 15px #d7d7d7",
                          marginTop: "-22px",
                          marginRight: "25px",
                        }}
                      >
                        <Dropdown.Item
                          className="d-flex align-items-center btn"
                          style={{
                            fontSize: "12px",
                            padding: "4px 21px",
                          }}
                          disabled={isCheckingTwilio}
                          onClick={() => {
                            checkTwilio();
                          }}
                        >
                          {isCheckingTwilio ? (
                            <span
                              className="spinner-border spinner-border-sm me-2"
                              role="status"
                            ></span>
                          ) : (
                            "Call Now"
                          )}
                        </Dropdown.Item>
                        <Dropdown.Item
                          className="d-flex align-items-center btn"
                          style={{
                            fontSize: "12px",
                            padding: "4px 21px",
                          }}
                          onClick={() => {
                            setCallLogOpen(true);
                          }}
                        >
                          Call log
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>{" "}
                    <button
                      type="button"
                      className="btn btn-default btnss"
                      onClick={fetchSmsKey}
                      style={styles.listButtonsStyles}
                    >
                      {" "}
                      {apiLoading.sms ? (
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      ) : integrationStatus.sms === "success" ? (
                        <>
                          <FontAwesomeIcon
                            icon={faMessage}
                            style={styles.iconStyles}
                          />
                          SMS
                        </>
                      ) : (
                        <>
                          {" "}
                          <FontAwesomeIcon
                            icon={faMessage}
                            style={styles.iconStyles}
                          />{" "}
                          SMS{" "}
                        </>
                      )}{" "}
                    </button>
                    <Dropdown className="dropdownsWithoutToggle">
                      <Dropdown.Toggle
                        variant="default"
                        style={styles.listButtonsStyless}
                        className="btn btn-default btnss"
                      >
                        <FontAwesomeIcon icon={faEllipsisVertical} />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item onClick={() => {
                          if (!companyGrants?.isEdit) {
                            toast.warning("You are not authorized for this action!")
                            return
                          }
                          handleReassignTask()
                        }}>
                          Reassign
                        </Dropdown.Item>
                        {showReassignModal && (
                          <Modal
                            show={showReassignModal}
                            onHide={handleReassingCancle}
                            backdrop="static"
                            keyboard={false}
                          >
                            <Modal.Header closeButton>
                              <Modal.Title>Reassign Task</Modal.Title>
                            </Modal.Header>
                            <Modal.Body>
                              <p
                                style={{
                                  color: "#787878",
                                  fontSize: 13,
                                  fontWeight: 200,
                                  marginBottom: "30px",
                                }}
                              >
                                This task has been reassigned to a new owner.
                                They will manage all next steps and provide
                                updates going forward.
                              </p>
                              <Select
                                styles={customSelectStyles}
                                options={users}
                                value={selectedUser}
                                onChange={setSelectedUser}
                                placeholder="Select a user"
                                isSearchable
                                className="mb-4"
                              />

                              <div className="mb-3 d-flex justify-content-end gap-2">
                                <Button
                                  variant="secondary"
                                  onClick={handleReassingCancle}
                                  className="btn btn-default-outline btn-sm"
                                >
                                  Cancel
                                </Button>
                                <Button
                                  variant="default"
                                  onClick={handleSubmit}
                                  disabled={!selectedUser}
                                  className="btn btn-default btn-sm"
                                >
                                  Submit
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        )}

                        <Dropdown.Item
                          onClick={() => {
                            if (!dealGrant?.isCreate) {
                              toast.warning("You are not authorized for this action!")
                              return
                            }
                            setShowAddDealOffcanvas(true)
                          }}

                        >
                          Add Deal
                        </Dropdown.Item>
                        <Dropdown.Item onClick={() => {
                          if (!contactGrants?.isCreate) {
                            toast.warning("You are not authorized for this action!")
                            return
                          }
                          setContactCanvas(true)
                        }}>
                          Add Contact
                        </Dropdown.Item>

                        {
                          <ContactForm
                            show={showContactCanvas} å
                            setShow={setContactCanvas}
                            companyId={companyId}
                            onClose={() => setShowCompanyDetails(false)}
                            companyGrants={companyGrants}
                            country={country}
                            masterGrant={masterGrant}
                          />
                        }
                        {/* <Dropdown.Item onClick={handleCloneClicked}>
                          Clone
                          </Dropdown.Item> */}

                        <Dropdown.Item onClick={() => {
                          if (!companyGrants?.isEdit) {
                            toast.warning("You are not authorized for this action!")
                            return
                          }
                          setShowOffcanvas(true)
                        }}>
                          Edit
                        </Dropdown.Item>
                        {/* {showOffcanvas && (
                          <EditCompanyOffcanvas
                            show={true}
                            company_data={company_data}
                            setShow={() => setShowOffcanvas(false)}
                            fetchData={refetch && refetch}
                            setFindData={setFindData}
                            findData={findData}
                            isCloneClicked={isCloneClicked}
                            setIsCloneClicked={setIsCloneClicked}
                          />
                        )} */}
                        <Dropdown.Item
                          onClick={() => {
                            if (!companyGrants?.isDelete) {
                              toast.warning("You are not authorized for this action!")
                              return
                            }
                            setConfirmDeleteId(allCompanies[nextPrevious].id);
                          }}
                        >
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <p
                      className="mb-0 mx-2 "
                      style={{ borderRight: "1px solid #c9c9c9", height: 29 }}
                    ></p>
                    <button
                      type="button"
                      className="btn btn-default btnss"
                      style={styles.listButtonsStyles}
                      onClick={onCanvasClose}
                    >
                      <FontAwesomeIcon icon={faXmark} className="ms-0" />
                    </button>
                  </div>
                </div>
              </div>
            )}
            {confirmDeleteId && (
              <DeleteModal
                show={true}
                onConfirm={() => handleDeleteCompany(confirmDeleteId)}
                onClose={() => setConfirmDeleteId(null)}
                isLoading={loading}
                message={"Are you sure to permanent delete this company"}
              />
            )}
            <div
              className=" pt-4"
              style={{
                borderRadius: "8px",
                background: "#f9f9f9",
                height: "92%",
              }}
            >
              <Row className="ms-0 w-100 h-100 pe-2">
                <Col
                  md={8}
                  className="ps-4 contactInformation"
                  style={{ height: "96%", paddingRight: 1, overflow: "auto" }}
                >
                  <div
                    className="me-2"
                    style={{
                      background: "#fff",
                      paddingTop: "12px",
                      borderRadius: "5px",
                      border: "1px solid #e0e4f8",
                      marginBottom: "10px",
                    }}
                  >
                    <div
                      className="d-flex gap-3 ms-3  mb-0 pb-0 pt-3"
                      style={styles.stickyHeader}
                    >
                      <div style={{ width: "10%" }}>
                        <div
                          className="overflow-hidden border border-2 d-flex justify-content-center align-items-center"
                          style={{
                            width: "100%",
                            height: "86%",
                            backgroundColor: "#fff",
                            borderColor: "#7a3a5e",
                            backgroundImage: companyData[0].company_image
                              ? `url(${companyData[0].company_image})`
                              : `url(${imgs})`,
                            backgroundPosition: "center",
                            backgroundSize: "111%",
                            backgroundRepeat: "no-repeat",
                          }}
                        ></div>
                      </div>
                      <div style={{ width: "85%" }}>
                        <div
                          style={{
                            color: "#576f91",
                            fontSize: "13px",
                            fontWeight: 500,
                          }}
                          className="d-flex justify-content-between align-items-center"
                        >
                          <div>
                            <h4
                              className="mb-1 d-flex align-items-center"
                              style={{
                                fontSize: "20px",
                                fontWeight: "500",
                                color: "#3c3c3c",
                              }}
                            >
                              <span className="companyOffcanvasName">
                                {companyData[0].company_name || "Company Name"}
                              </span>
                              <span
                                style={{ color: "#3f97fd", marginLeft: "4px" }}
                              >
                                ({companyData[0].company_no ? `#${companyData[0]?.company_no}` : "-"})
                              </span>
                              <span
                                style={{
                                  verticalAlign: "super",
                                  marginLeft: "4px",
                                }}
                              >
                                {renderStarRating(companyData[0].rating)}
                              </span>
                            </h4>
                            <p className="mb-0">
                              {companyData[0].industry || "Industry"} |{" "}
                              {companyData[0].business_type || "Business Type"}
                            </p>
                          </div>
                        </div>
                        <div
                          className="  pt-3 ps-0 pb-0"
                          style={{
                            background: "transparent",
                            marginTop: "0rem",
                            marginLeft: "0rem",
                          }}
                        >
                          <Row className="w-100 ms-0 mb-2 ">
                            <Col
                              md={6}
                              className="mb-3 d-flex align-items-center"
                            >
                              <FontAwesomeIcon
                                icon={faEnvelope}
                                style={styles.iconsStyles}
                                className=" fs-16"
                              />
                              <div>
                                <p className="mb-0" style={styles.labels}>
                                  Email
                                </p>
                                <p className="mb-0" style={styles.values}>
                                  {userEmail?.email ||
                                    companyData[0].email ||
                                    "-"}
                                </p>
                              </div>
                            </Col>
                            <Col
                              md={6}
                              className="mb-3 d-flex align-items-center"
                              onClick={() => checkTwilio()}
                              style={{ cursor: 'pointer' }}
                            >
                              <FontAwesomeIcon
                                icon={faPhone}
                                style={styles.iconsStyles}
                                className=" fs-16"
                              />
                              <div>
                                <p className="mb-0" style={styles.labels}>
                                  Phone
                                </p>
                                <p className="mb-0" style={styles.values}>
                                  {/* {(userPhone?.phone &&
                                    " " +
                                    userPhone.country_code +
                                    " " +
                                    userPhone.phone) ||
                                    "-"} */}
                                  {
                                    userPhone?.phone
                                      ?
                                      `${userPhone.country_code} ${maskContactNumber(userPhone.phone)}`
                                      : "-"
                                  }
                                </p>
                              </div>
                            </Col>
                            <Col
                              md={6}
                              className="mb-3 d-flex align-items-center"
                            >
                              <FontAwesomeIcon
                                icon={faLocationDot}
                                className=" fs-16"
                                style={styles.iconsStyles}
                              />
                              <div>
                                <p className="mb-0" style={styles.labels}>
                                  Address
                                </p>
                                <div className="mb-0" style={styles.values}>
                                  {hideShow(`${companyData[0].address || '-'}`)}
                                </div>
                              </div>
                            </Col>
                            <Col
                              md={6}
                              className="mb-3 d-flex align-items-center"
                            >
                              <FontAwesomeIcon
                                icon={faLocationDot}
                                className=" fs-16"
                                style={styles.iconsStyles}
                              />
                              <div>
                                <p className="mb-0" style={styles.labels}>
                                  Website
                                </p>
                                <p className="mb-0" style={styles.values}>
                                  {companyData[0].website || "-"}
                                </p>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Row
                    className="w-100 ms-0 mt-2 ps-0 pe-2"
                    style={{ minHeight: "390px" }}
                  >
                    <Col
                      md={12}
                      className="tab-container bg-white ps-0 pe-0"
                      style={styles.tabContainer}
                    >
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex gap-1 align-items-center mx-3">
                          <h4
                            style={{
                              fontSize: associatedDeals ? 15 : 20,
                              fontWeight: 300,
                              color: associatedDeals ? "gray" : "black",
                              cursor: "pointer",
                            }}
                            className="my-3 "
                            onClick={() => {
                              setAssociatedDeals(false);
                            }}
                          >
                            Associated Leads
                          </h4>
                          <span>|</span>
                          <h4
                            style={{
                              fontSize: associatedDeals ? 20 : 15,
                              fontWeight: 300,
                              color: associatedDeals ? "black" : "gray",
                              cursor: "pointer",
                            }}
                            className="my-3 "
                            onClick={() => {
                              setAssociatedDeals(true);
                              fetchAllDeals();
                            }}
                          >
                            Associated Deals
                          </h4>
                        </div>
                        {/* //leads div for add and listing leads */}
                        {!associatedDeals && (
                          <div
                            className="d-flex align-items-center gap-2 pe-3"
                          //  style={{display:associatedDeals ? "none" : "block"}}
                          >
                            <p
                              className="mb-0"
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                cursor: "pointer",
                                color: "#0099ff"
                              }}
                              onClick={() => {
                                if (!leadGrant?.isCreate) {
                                  toast.warning("You are not authorized for this action!")
                                  return
                                }
                                setShowAddLeadsOffcanvas(true);
                              }}
                            >
                              Add Lead
                            </p>
                            <p
                              className="mb-0 mx-2 "
                              style={{
                                borderRight: "1px solid #c9c9c9",
                                height: 19,
                              }}
                            ></p>
                            <p
                              className="mb-0"
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                cursor: "pointer",
                                color: "#0099ff"
                              }}
                              onClick={() => {
                                if (!leadGrant?.isView) {
                                  toast.warning("You are not authorized for this action!")
                                  return
                                }
                                window.open(
                                  `${window.location.origin}/leads?module=company&id=${allCompanies[nextPrevious].id}`,
                                  "_blank"
                                )
                              }}
                            >
                              List All Leads
                            </p>
                          </div>
                        )}

                        {/* // deals div for add and listing deals */}
                        {associatedDeals && (
                          <div
                            className="d-flex align-items-center gap-2 pe-3"
                          // style={{display:associatedDeals?"block" : "none"}}
                          >
                            <p
                              className="mb-0"
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                cursor: "pointer",
                                color: "#0099ff"
                              }}
                              onClick={() => {
                                if (!dealGrant?.isCreate) {
                                  toast.warning("You are not authorized for this action!")
                                  return
                                }
                                setShowAddDealOffcanvas(true);
                              }}
                            >
                              Add Deal
                            </p>
                            <p
                              className="mb-0 mx-2 "
                              style={{
                                borderRight: "1px solid #c9c9c9",
                                height: 19,
                              }}
                            ></p>
                            <p
                              className="mb-0"
                              style={{
                                fontSize: 12,
                                fontWeight: 400,
                                cursor: "pointer",
                                color: "#0099ff"
                              }}
                              onClick={() => {
                                if (!dealGrant?.isView) {
                                  toast.warning("You are not authorized for this action!")
                                  return
                                }
                                window.open(
                                  `${window.location.origin}/deals?module=company&id=${allCompanies[nextPrevious].id}`,
                                  "_blank"
                                )
                              }
                              }
                            >
                              List All Deals
                            </p>
                          </div>
                        )}
                      </div>
                      {associatedDeals ? (
                        // deals tab container
                        <Tab.Container defaultActiveKey="Communications">
                          <Nav
                            variant="pills"
                            className="nav-style-1 mb-0 d-flex flex-nowrap newNavTab associatedDeals gap-1 mx-0"
                          >
                            <Nav.Item
                              className="me-0"
                              style={{ minWidth: "17%" }}
                              onClick={() => {
                                // setLeads([]);
                                setDealStatus("");
                                fetchAllDeals();
                              }}
                            >
                              <Nav.Link
                                eventKey="Communications"
                                style={styles.navLinksStyle}
                              >
                                <p className="d-flex justify-content-between mb-1 text-white">
                                  All Deals{" "}
                                  <FontAwesomeIcon icon={faDollarSign} />
                                </p>
                                <p
                                  className="mb-0 mt-2 d-flex justify-content-between text-white"
                                  style={{ fontSize: "25px", fontWeight: 300 }}
                                >
                                  {putCommaInLeadsValue(
                                    dealsCardData?.allDeals || 0
                                  )}
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      textAlign: "end",
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontWeight: 200,
                                        fontSize: 10,
                                        color: "white",
                                      }}
                                    >
                                      Approx Value INR
                                    </p>
                                    <span className="text-white">
                                      {formatToINR(
                                        dealsCardData?.total_revenue || "0"
                                      )}
                                    </span>
                                  </span>
                                </p>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                              className="me-0"
                              style={{
                                minWidth: "17%",
                                cursor:
                                  dealsCardData?.won == 0
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={() => {
                                if (dealsCardData?.won == 0) {
                                  return;
                                } else {
                                  setContactDeals([]);
                                  setDealStatus("won");
                                  fetchDealsByStatus();
                                }
                              }}
                            >
                              <Nav.Link
                                eventKey="Locations"
                                style={styles.inActiveNavLinksStyle}
                              >
                                <p className="d-flex justify-content-between mb-1 text-white">
                                  Won Deals{" "}
                                  <FontAwesomeIcon icon={faBriefcase} />
                                </p>
                                <p
                                  className="mb-0 mt-2 d-flex justify-content-between text-white"
                                  style={{ fontSize: "25px", fontWeight: 300 }}
                                >
                                  {putCommaInLeadsValue(
                                    dealsCardData?.won || 0
                                  )}
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      textAlign: "end",
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontWeight: 200,
                                        fontSize: 10,
                                        color: "white",
                                      }}
                                    >
                                      Approx Value INR
                                    </p>
                                    <span className="text-white">
                                      {formatToINR(
                                        dealsCardData?.won_revenue || "0"
                                      )}
                                    </span>
                                  </span>
                                </p>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                              className="me-0"
                              style={{
                                minWidth: "17%",
                                cursor:
                                  dealsCardData?.lost == 0
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={() => {
                                if (dealsCardData?.lost == 0) {
                                  return;
                                } else {
                                  setContactDeals([]);
                                  setDealStatus("lost");
                                  fetchDealsByStatus();
                                }
                              }}
                            >
                              <Nav.Link
                                eventKey="Socials"
                                style={styles.inActiveNavLinksStyle}
                              >
                                <p className="d-flex justify-content-between mb-1 text-white">
                                  Lost Deals <FontAwesomeIcon icon={faUser} />
                                </p>
                                <p
                                  className="mb-0 mt-2 d-flex justify-content-between text-white"
                                  style={{ fontSize: "25px", fontWeight: 300 }}
                                >
                                  {putCommaInLeadsValue(
                                    dealsCardData?.lost || 0
                                  )}
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      textAlign: "end",
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontWeight: 200,
                                        fontSize: 10,
                                        color: "white",
                                      }}
                                    >
                                      Approx Value INR
                                    </p>
                                    <span className="text-white">
                                      {formatToINR(
                                        dealsCardData?.lost_revenue || "0"
                                      )}
                                    </span>
                                  </span>
                                </p>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                              className="me-0"
                              style={{
                                minWidth: "17%",
                                cursor:
                                  dealsCardData?.unqualified == 0
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={() => {
                                if (dealsCardData?.unqualified == 0) {
                                  return;
                                } else {
                                  setContactDeals([]);
                                  setDealStatus("unqualified");
                                  fetchDealsByStatus();
                                }
                              }}
                            >
                              <Nav.Link
                                eventKey="Socials"
                                style={styles.inActiveNavLinksStyle}
                              >
                                <p className="d-flex justify-content-between mb-1 text-white">
                                  Unqualified Deals{" "}
                                  <FontAwesomeIcon icon={faUserLock} />
                                </p>
                                <p
                                  className="mb-0 mt-2 d-flex justify-content-between text-white"
                                  style={{ fontSize: "25px", fontWeight: 300 }}
                                >
                                  {putCommaInLeadsValue(
                                    dealsCardData?.unqualified || 0
                                  )}
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      textAlign: "end",
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontWeight: 200,
                                        fontSize: 10,
                                        color: "white",
                                      }}
                                    >
                                      Approx Value INR
                                    </p>
                                    <span className="text-white">
                                      {formatToINR(
                                        dealsCardData?.unqualified_revenue ||
                                        "0"
                                      )}
                                    </span>
                                  </span>
                                </p>
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                          <Tab.Content>
                            <Tab.Pane
                              className="p-0 pt-3 pb-3"
                              eventKey="Communications"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            >
                              <div className="table-responsive" style={{ maxHeight: "15rem", minHeight: "15rem" }}>
                                <table className="table Communications listStyleForContact">
                                  <thead>
                                    <tr>
                                      <th style={{ borderRadius: 0 }}>#</th>
                                      {/* <th>Lead Title</th> */}
                                      <th>Owner</th>
                                      <th>Budget</th>
                                      <th>Closure Date</th>
                                      <th>Pipeline</th>
                                      <th>Stage</th>
                                      <th>Status</th>
                                      <th style={{ borderRadius: 0 }}>
                                        Created on
                                      </th>
                                      <th>Requirement</th>
                                      <th
                                        className="lastactionTd"
                                        style={styles.lastdStyle}
                                      ></th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {
                                      dealGrant?.isView ?
                                        deals?.length === 0 ?
                                          contactDeals?.deals_list && contactDeals?.deals_list?.length > 0
                                            ?
                                            contactDeals.deals_list.map(
                                              (val, index) => {
                                                let services = [];
                                                try {
                                                  services = JSON.parse(
                                                    val?.product_services || "[]"
                                                  );
                                                } catch (e) {
                                                  services = [];
                                                }
                                                const totalBudget = services.reduce(
                                                  (sum, obj) =>
                                                    sum +
                                                    parseFloat(obj.budget || 0),
                                                  0
                                                );

                                                return (
                                                  <tr key={val.id || index}>
                                                    <td>{index + 1}</td>
                                                    <td
                                                      className="text-primary"
                                                      onClick={() => {
                                                        handleDealDetailPage(val);
                                                      }}
                                                      style={{ cursor: "pointer" }}
                                                    >
                                                      {val.owner_name || "-"}
                                                    </td>
                                                    <td>
                                                      <p
                                                        className="mb-0 fs-12"
                                                        style={{
                                                          color: "#17c417",
                                                          fontWeight: 500,
                                                        }}
                                                      >
                                                        {putCommaInLeadsValue(
                                                          totalBudget
                                                        )}
                                                      </p>
                                                    </td>
                                                    <td>
                                                      {formatDate(
                                                        val.expected_closure_date
                                                      ) || "-"}
                                                    </td>
                                                    <td>
                                                      {val.pipeline_name || "-"}
                                                    </td>
                                                    <td>{val.stage_name || "-"}</td>
                                                    <td>
                                                      <p>
                                                        {val.deal_status || "-"}
                                                      </p>
                                                    </td>
                                                    <td>
                                                      {formatDate(val.created_at)}
                                                    </td>
                                                    <td>
                                                      {val.requirement || "-"}
                                                    </td>
                                                    <td
                                                      className="lastactionTd"
                                                      style={{
                                                        ...styles.lastdStyle,
                                                        zIndex:
                                                          openRow === val.id
                                                            ? 11
                                                            : "auto",
                                                      }}
                                                    >
                                                      <div className="endTdDiv">
                                                        <Dropdown
                                                          as="div"
                                                          className="dropdownsWithoutToggle"
                                                          onToggle={(isOpen) =>
                                                            setOpenRow(
                                                              isOpen ? val.id : null
                                                            )
                                                          }
                                                        >
                                                          <Dropdown.Toggle
                                                            as={Nav.Link}
                                                            className="header-link"
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={
                                                                faEllipsisVertical
                                                              }
                                                              style={{
                                                                fontSize: "15px",
                                                                width: "20px",
                                                                color: "#536485",
                                                              }}
                                                            />
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu
                                                            align="end"
                                                            style={{
                                                              width: "8rem",
                                                              boxShadow:
                                                                "0 0 15px #d7d7d7",
                                                              marginTop: "-22px",
                                                              marginRight: "25px",
                                                            }}
                                                          >
                                                            <Dropdown.Item
                                                              className="d-flex align-items-center btn"
                                                              style={{
                                                                fontSize: "12px",
                                                                padding: "4px 21px",
                                                              }}
                                                              onClick={() => {
                                                                if (!dealGrant?.isEdit) {
                                                                  toast.warning("You are not authorized for this action!")
                                                                  return
                                                                }
                                                                setEditDealId(
                                                                  val.id
                                                                );
                                                                setShowUpdateDealOffcanvas(
                                                                  true
                                                                );
                                                              }}
                                                            >
                                                              Edit
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                              className="d-flex align-items-center btn"
                                                              style={{
                                                                fontSize: "12px",
                                                                padding: "4px 21px",
                                                              }}
                                                              onClick={() => {
                                                                if (!dealGrant?.isDelete) {
                                                                  toast.warning("You are not authorized for this action!")
                                                                  return
                                                                }
                                                                setDeleteDealId(
                                                                  val.id
                                                                );
                                                                setShowDealDeleteModal(
                                                                  true
                                                                );
                                                              }}
                                                            >
                                                              Delete
                                                            </Dropdown.Item>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            )
                                            :
                                            <>
                                              <div
                                                class="d-flex justify-content-center align-items-center"
                                                style={{ position: "absolute", left: " 42%" }}
                                              >
                                                <img
                                                  src={nodata}
                                                  alt=""
                                                  style={{ width: "12rem", marginTop: "0" }}
                                                />
                                              </div>
                                            </>
                                          : deals && deals?.map((val, index) => {
                                            return (
                                              <tr key={index}>
                                                <td>{index + 1}</td>
                                                <td>
                                                  {val.owner_name
                                                    ? val.owner_name
                                                    : "-"}
                                                </td>
                                                <td>
                                                  <p
                                                    className="mb-0 fs-12"
                                                    style={{
                                                      color: "#17c417 ",
                                                      fontWeight: 500,
                                                    }}
                                                  >
                                                    {putCommaInLeadsValue(
                                                      JSON.parse(
                                                        val.product_services
                                                      )?.reduce(
                                                        (sum, obj) =>
                                                          sum +
                                                          parseFloat(
                                                            obj.budget || 0
                                                          ),
                                                        0
                                                      )
                                                    )}
                                                  </p>
                                                </td>
                                                <td>
                                                  {val.expected_closure_date}
                                                </td>
                                                <td>{val.pipeline_name}</td>
                                                <td>{val.stage_name}</td>

                                                <td>
                                                  {val.deal_status
                                                    ? val.deal_status
                                                    : "-"}
                                                </td>
                                                <td>
                                                  {formatDate(val.created_at)}
                                                </td>
                                                <td>{val.requirement}</td>
                                                <td
                                                  className="lastactionTd"
                                                  style={{
                                                    ...styles.lastdStyle, // spread karo object ko
                                                    zIndex:
                                                      openRow === val.id
                                                        ? 11
                                                        : "auto",
                                                  }}
                                                >
                                                  <div className="endTdDiv">
                                                    <Dropdown
                                                      as="div"
                                                      className="dropdownsWithoutToggle"
                                                      onToggle={(isOpen) =>
                                                        setOpenRow(
                                                          isOpen ? val.id : null
                                                        )
                                                      }
                                                    >
                                                      <Dropdown.Toggle
                                                        as={Nav.Link}
                                                        className="header-link"
                                                      >
                                                        <FontAwesomeIcon
                                                          icon={
                                                            faEllipsisVertical
                                                          }
                                                          style={{
                                                            fontSize: "15px",
                                                            width: "20px",
                                                            color: "#536485",
                                                          }}
                                                        />
                                                      </Dropdown.Toggle>
                                                      <Dropdown.Menu
                                                        align={"end"}
                                                        style={{
                                                          width: "8rem",
                                                          inset:
                                                            "0px auto auto 0px",
                                                          boxShadow:
                                                            "rgb(215, 215, 215) 0px 0px 15px",
                                                          position: "absolute",
                                                          marginTop: "-22px",
                                                          marginRight: "25px",
                                                          minWidth: "3rem",
                                                        }}
                                                      >
                                                        <Dropdown.Item
                                                          style={{
                                                            fontSize: "12px",
                                                            padding: "4px 21px",
                                                          }}
                                                          className="d-flex align-items-center btn"
                                                          onClick={() => {
                                                            if (!dealGrant?.isEdit) {
                                                              toast.warning("You are not authorized for this action!")
                                                              return
                                                            }
                                                            setEditDealId(val.id);
                                                            setShowUpdateDealOffcanvas(
                                                              true
                                                            );
                                                          }}
                                                        >
                                                          {" "}
                                                          Edit{" "}
                                                        </Dropdown.Item>
                                                        <Dropdown.Item
                                                          style={{
                                                            fontSize: "12px",
                                                            padding: "4px 21px",
                                                          }}
                                                          className="d-flex align-items-center btn"
                                                          onClick={() => {
                                                            if (!dealGrant?.isDelete) {
                                                              toast.warning("You are not authorized for this action")
                                                              return
                                                            }
                                                            setDeleteDealId(
                                                              val.id
                                                            );
                                                            setShowDealDeleteModal(
                                                              true
                                                            );
                                                          }}
                                                        >
                                                          {" "}
                                                          Delete{" "}
                                                        </Dropdown.Item>
                                                      </Dropdown.Menu>
                                                    </Dropdown>
                                                  </div>
                                                </td>
                                              </tr>
                                            );
                                          })
                                        :
                                        <td colSpan={10}>
                                          <UnauthorizedTableState tabName={"Deals"} />
                                        </td>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </Tab.Pane>
                            <Tab.Pane
                              eventKey="Locations"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            ></Tab.Pane>
                            <Tab.Pane
                              eventKey="Socials"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            ></Tab.Pane>
                          </Tab.Content>
                        </Tab.Container>
                      ) : (
                        // deals tab container end
                        // leads tab container
                        <Tab.Container defaultActiveKey="Communications">
                          <Nav
                            variant="pills"
                            className="nav-style-1 mb-0 d-flex flex-nowrap newNavTab associatedDeals gap-1 mx-0"
                          >
                            <Nav.Item
                              className="me-0"
                              style={{ minWidth: "17%" }}
                              onClick={() => {
                                setLeads([]);
                                setLeadsStatus({});
                                fetchCompanyDetails();
                                setOnclickedLead(true);
                              }}
                            >
                              <Nav.Link
                                eventKey="Communications"
                                style={styles.navLinksStyle}
                              >
                                <p className="d-flex justify-content-between mb-1 text-white">
                                  All Leads{" "}
                                  <FontAwesomeIcon icon={faDollarSign} />
                                </p>
                                <p
                                  className="mb-0 mt-2 d-flex justify-content-between text-white "
                                  style={{
                                    fontSize: "25px",
                                    fontWeight: 300,
                                  }}
                                >
                                  {putCommaInLeadsValue(
                                    contactDetails?.total_leads || 0
                                  )}
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      textAlign: "end",
                                      color: "white",
                                    }}
                                  >
                                    <p
                                      className="mb-0 text-white  "
                                      style={{
                                        fontWeight: 200,
                                        fontSize: 10,
                                        color: "white",
                                      }}
                                    >
                                      Approx Value INR
                                    </p>
                                    <span className="text-white">
                                      {formatToINR(
                                        contactDetails?.total_revenue || "0"
                                      )}
                                    </span>
                                  </span>
                                </p>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                              className="me-0"
                              style={{
                                minWidth: "17%",
                                cursor:
                                  contactDetails?.won_leads?.[0]
                                    .total_won_leads == 0
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={() => {
                                if (
                                  contactDetails?.won_leads?.[0]
                                    .total_won_leads == 0
                                ) {
                                  return;
                                } else {
                                  setLeadsStatus("won");
                                }
                              }}
                            >
                              <Nav.Link
                                eventKey="Locations"
                                style={styles.inActiveNavLinksStyle}
                              >
                                <p className="d-flex justify-content-between mb-1 text-white ">
                                  Won Leads{" "}
                                  <FontAwesomeIcon icon={faBriefcase} />
                                </p>
                                <p
                                  className="mb-0 mt-2 d-flex justify-content-between text-white "
                                  style={{
                                    fontSize: "25px",
                                    fontWeight: 300,
                                  }}
                                >
                                  {putCommaInLeadsValue(
                                    contactDetails?.won || 0
                                  )}
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      textAlign: "end",
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontWeight: 200,
                                        fontSize: 10,
                                        color: "white",
                                      }}
                                    >
                                      Approx Value INR
                                    </p>
                                    <span className="text-white">
                                      {formatToINR(
                                        contactDetails?.total_revenue_won || "0"
                                      )}
                                    </span>
                                  </span>
                                </p>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                              className="me-0"
                              style={{
                                minWidth: "17%",
                                cursor:
                                  contactDetails?.lost_leads?.[0]
                                    .total_lost_leads == 0
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={() => {
                                if (
                                  contactDetails?.lost_leads?.[0]
                                    .total_lost_leads == 0
                                ) {
                                  return;
                                } else {
                                  setLeadsStatus("lost");
                                }
                              }}
                            >
                              <Nav.Link
                                eventKey="Socials"
                                style={styles.inActiveNavLinksStyle}
                              >
                                <p className="d-flex justify-content-between mb-1 text-white">
                                  Lost Leads <FontAwesomeIcon icon={faUser} />
                                </p>
                                <p
                                  className="mb-0 mt-2 d-flex justify-content-between text-white"
                                  style={{
                                    fontSize: "25px",
                                    fontWeight: 300,
                                  }}
                                >
                                  {putCommaInLeadsValue(
                                    contactDetails?.lost || 0
                                  )}
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      textAlign: "end",
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontWeight: 200,
                                        fontSize: 10,
                                        color: "white",
                                      }}
                                    >
                                      Approx Value INR
                                    </p>
                                    <span className="text-white">
                                      {formatToINR(
                                        contactDetails?.total_revenue_lost ||
                                        "0"
                                      )}
                                    </span>
                                  </span>
                                </p>
                              </Nav.Link>
                            </Nav.Item>
                            <Nav.Item
                              className="me-0"
                              style={{
                                minWidth: "17%",
                                cursor:
                                  contactDetails?.unqualified_leads?.[0]
                                    .total_unqualified_leads == 0
                                    ? "not-allowed"
                                    : "pointer",
                              }}
                              onClick={() => {
                                if (
                                  contactDetails?.unqualified_leads?.[0]
                                    .total_unqualified_leads == 0
                                ) {
                                  return;
                                } else {
                                  setLeadsStatus("unqualified");
                                }
                              }}
                            >
                              <Nav.Link
                                eventKey="Socials"
                                style={styles.inActiveNavLinksStyle}
                              >
                                <p className="d-flex justify-content-between mb-1 text-white">
                                  Unqualified Leads{" "}
                                  <FontAwesomeIcon icon={faUserLock} />
                                </p>
                                <p
                                  className="mb-0 mt-2 d-flex justify-content-between text-white"
                                  style={{
                                    fontSize: "25px",
                                    fontWeight: 300,
                                  }}
                                >
                                  {putCommaInLeadsValue(
                                    contactDetails?.unqualified || 0
                                  )}
                                  <span
                                    style={{
                                      fontSize: "12px",
                                      fontWeight: 400,
                                      textAlign: "end",
                                    }}
                                  >
                                    <p
                                      className="mb-0"
                                      style={{
                                        fontWeight: 200,
                                        fontSize: 10,
                                        color: "white",
                                      }}
                                    >
                                      Approx Value INR
                                    </p>
                                    <span className="text-white">
                                      {formatToINR(
                                        contactDetails?.total_revenue_unqualified ||
                                        "0"
                                      )}
                                    </span>
                                  </span>
                                </p>
                              </Nav.Link>
                            </Nav.Item>
                          </Nav>
                          <Tab.Content>
                            <Tab.Pane
                              className="p-0 pt-3 pb-3"
                              eventKey="Communications"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            >
                              <div className="table-responsive" style={{ maxHeight: "15rem", minHeight: "15rem" }}>
                                <table className="table Communications listStyleForContact">
                                  <thead>
                                    <tr>
                                      <th style={{ borderRadius: 0 }}>#</th>
                                      {/* <th>Lead Title</th> */}
                                      <th>Lead owner</th>
                                      <th>Budget</th>
                                      <th>Closure Date</th>
                                      <th>Pipeline</th>
                                      <th>Stage</th>
                                      <th>status</th>
                                      <th style={{ borderRadius: 0 }}>
                                        Created On
                                      </th>
                                      <th>Requirement</th>
                                      <th
                                        className="lastactionTd"
                                        style={styles.lastdStyle}
                                      ></th>
                                    </tr>
                                  </thead>
                                  {/* {console.log("object", leads?.length)} */}
                                  <tbody>
                                    {
                                      leadGrant?.isView ?
                                        leads?.length === 0
                                          ?
                                          contactDetails[0]?.contact_list?.map(
                                            (item) =>
                                              item?.leads?.length > 0 ?
                                                item?.leads?.map((val, index) => {
                                                  return (
                                                    <tr
                                                      key={`comm - ${item.id} - ${index}`}
                                                    >
                                                      {console.log("object", item)}
                                                      <td>{idx++}</td>
                                                      {/* <td>?</td> */}
                                                      <td
                                                        className="text-primary"
                                                        onClick={() => {
                                                          handleOnLeadClick(val);
                                                        }}
                                                        style={{ cursor: "pointer" }}
                                                      >
                                                        {val.owner_name}
                                                      </td>
                                                      <td>
                                                        <p
                                                          className="mb-0 fs-12"
                                                          style={{
                                                            color: "#17c417 ",
                                                            fontWeight: 500,
                                                          }}
                                                        >

                                                          {!val?.product_services ||
                                                            val.product_services ===
                                                            "null"
                                                            ? "-"
                                                            : (() => {
                                                              try {
                                                                const arr =
                                                                  JSON.parse(
                                                                    val.product_services
                                                                  );
                                                                if (
                                                                  !Array.isArray(
                                                                    arr
                                                                  ) ||
                                                                  arr.length === 0
                                                                )
                                                                  return "-";
                                                                const total =
                                                                  arr.reduce(
                                                                    (sum, obj) =>
                                                                      sum +
                                                                      parseFloat(
                                                                        obj?.budget ||
                                                                        0
                                                                      ),
                                                                    0
                                                                  );
                                                                return putCommaInLeadsValue(
                                                                  total
                                                                );
                                                              } catch (e) {
                                                                return "-";
                                                              }
                                                            })()}
                                                        </p>
                                                      </td>
                                                      <td>
                                                        {formatDate(
                                                          val.expected_closure_date
                                                        ) || "-"}
                                                      </td>
                                                      <td>
                                                        {val.pipeline_name
                                                          ? val.pipeline_name
                                                          : "-"}
                                                      </td>
                                                      <td>{val.stage_name}</td>
                                                      <td>
                                                        <p>
                                                          {val.lead_status
                                                            ? val.lead_status
                                                            : "-"}
                                                        </p>
                                                      </td>
                                                      <td>
                                                        {formatDate(val.created_at)}
                                                      </td>
                                                      <td>{val.requirement}</td>
                                                      <td
                                                        className="lastactionTd"
                                                        style={{
                                                          ...styles.lastdStyle,
                                                          zIndex:
                                                            openRow === val.id
                                                              ? 11
                                                              : "auto",
                                                        }}
                                                      >
                                                        <div className="endTdDiv">
                                                          <Dropdown
                                                            as="div"
                                                            className="dropdownsWithoutToggle"
                                                            onToggle={(isOpen) =>
                                                              setOpenRow(
                                                                isOpen
                                                                  ? val.id
                                                                  : null
                                                              )
                                                            }
                                                          >
                                                            <Dropdown.Toggle
                                                              as={Nav.Link}
                                                              className="header-link"
                                                            >
                                                              <FontAwesomeIcon
                                                                icon={
                                                                  faEllipsisVertical
                                                                }
                                                                style={{
                                                                  fontSize: "15px",
                                                                  width: "20px",
                                                                  color: "#536485",
                                                                }}
                                                              />
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu
                                                              align={"end"}
                                                              style={{
                                                                width: "8rem",
                                                                inset:
                                                                  "0px auto auto 0px",
                                                                boxShadow:
                                                                  "rgb(215, 215, 215) 0px 0px 15px",
                                                                position:
                                                                  "absolute",
                                                                marginTop: "-22px",
                                                                marginRight: "25px",
                                                                minWidth: "3rem",
                                                              }}
                                                            >
                                                              <Dropdown.Item
                                                                style={{
                                                                  fontSize: "12px",
                                                                  padding:
                                                                    "4px 21px",
                                                                }}
                                                                className="d-flex align-items-center btn"
                                                                onClick={() => {
                                                                  if (!leadGrant?.isEdit) {
                                                                    toast.warning("You are not authorized for this action!")
                                                                    return
                                                                  }
                                                                  setEditLeadId(
                                                                    val.id
                                                                  );
                                                                  setShowAddLeadsOffcanvas(
                                                                    true
                                                                  );
                                                                }}
                                                              >
                                                                {" "}
                                                                Edit{" "}
                                                              </Dropdown.Item>
                                                              <Dropdown.Item
                                                                style={{
                                                                  fontSize: "12px",
                                                                  padding:
                                                                    "4px 21px",
                                                                }}
                                                                className="d-flex align-items-center btn"
                                                                onClick={() => {
                                                                  if (!leadGrant?.isDelete) {
                                                                    toast.warning("You are not authorized for this action!")
                                                                    return
                                                                  }
                                                                  setDeleteLeadId(
                                                                    val.id
                                                                  );
                                                                  setShowLeadDeleteModal(
                                                                    true
                                                                  );
                                                                }}
                                                              >
                                                                {" "}
                                                                Delete{" "}
                                                              </Dropdown.Item>
                                                            </Dropdown.Menu>
                                                          </Dropdown>
                                                        </div>
                                                      </td>
                                                    </tr>
                                                  );
                                                })
                                                :
                                                <>
                                                  <div
                                                    class="d-flex justify-content-center align-items-center"
                                                    style={{ position: "absolute", left: " 42%" }}
                                                  >
                                                    <img
                                                      src={nodata}
                                                      alt=""
                                                      style={{ width: "12rem", marginTop: "0" }}
                                                    />
                                                  </div>
                                                </>
                                          )
                                          : leads && leads?.map((lead) =>
                                            lead.fetch_leads?.map(
                                              (val, index) => {
                                                return (
                                                  <tr key={index}>
                                                    <td>{idx++}</td>
                                                    <td>{val.owner_name}</td>
                                                    <td>
                                                      <p
                                                        className="mb-0 fs-12"
                                                        style={{
                                                          color: "#17c417 ",
                                                          fontWeight: 500,
                                                        }}
                                                      >


                                                        {!val?.product_services ||
                                                          val.product_services ===
                                                          "null"
                                                          ? "-"
                                                          : putCommaInLeadsValue(
                                                            (() => {
                                                              try {
                                                                const arr =
                                                                  JSON.parse(
                                                                    val.product_services
                                                                  );
                                                                if (
                                                                  !Array.isArray(
                                                                    arr
                                                                  ) ||
                                                                  arr.length ===
                                                                  0
                                                                )
                                                                  return 0;
                                                                return arr.reduce(
                                                                  (sum, obj) =>
                                                                    sum +
                                                                    parseFloat(
                                                                      obj?.budget ||
                                                                      0
                                                                    ),
                                                                  0
                                                                );
                                                              } catch (e) {
                                                                return 0;
                                                              }
                                                            })()
                                                          )}
                                                      </p>
                                                    </td>
                                                    <td>{val.pipeline_name}</td>
                                                    <td>{val.stage_name}</td>
                                                    <td>
                                                      {val.lead_status
                                                        ? val.lead_status
                                                        : "-"}
                                                    </td>
                                                    <td>
                                                      {formatDate(val.created_at)}
                                                    </td>
                                                    <td>{val.requirement}</td>
                                                    <td
                                                      className="lastactionTd"
                                                      style={{
                                                        ...styles.lastdStyle, // spread karo object ko
                                                        zIndex:
                                                          openRow === val.id
                                                            ? 11
                                                            : "auto",
                                                      }}
                                                    >
                                                      <div className="endTdDiv">
                                                        <Dropdown
                                                          as="div"
                                                          className="dropdownsWithoutToggle"
                                                          onToggle={(isOpen) =>
                                                            setOpenRow(
                                                              isOpen
                                                                ? val.id
                                                                : null
                                                            )
                                                          }
                                                        >
                                                          <Dropdown.Toggle
                                                            as={Nav.Link}
                                                            className="header-link"
                                                          >
                                                            <FontAwesomeIcon
                                                              icon={
                                                                faEllipsisVertical
                                                              }
                                                              style={{
                                                                fontSize: "15px",
                                                                width: "20px",
                                                                color: "#536485",
                                                              }}
                                                            />
                                                          </Dropdown.Toggle>
                                                          <Dropdown.Menu
                                                            align={"end"}
                                                            style={{
                                                              width: "8rem",
                                                              inset:
                                                                "0px auto auto 0px",
                                                              boxShadow:
                                                                "rgb(215, 215, 215) 0px 0px 15px",
                                                              position:
                                                                "absolute",
                                                              marginTop: "-22px",
                                                              marginRight: "25px",
                                                              minWidth: "3rem",
                                                            }}
                                                          >
                                                            <Dropdown.Item
                                                              style={{
                                                                fontSize: "12px",
                                                                padding:
                                                                  "4px 21px",
                                                              }}
                                                              className="d-flex align-items-center btn"
                                                              onClick={() => {
                                                                if (!leadGrant?.isEdit) {
                                                                  toast.warning("You are not authorized for this action!")
                                                                  return
                                                                }
                                                                setEditLeadId(
                                                                  val.id
                                                                );
                                                                setShowAddLeadsOffcanvas(
                                                                  true
                                                                );
                                                              }}
                                                            >
                                                              {" "}
                                                              Edit{" "}
                                                            </Dropdown.Item>
                                                            <Dropdown.Item
                                                              style={{
                                                                fontSize: "12px",
                                                                padding:
                                                                  "4px 21px",
                                                              }}
                                                              className="d-flex align-items-center btn"
                                                              onClick={() => {
                                                                if (!leadGrant?.isDelete) {
                                                                  toast.warning("You are not authorized for this action!")
                                                                  return
                                                                }
                                                                setDeleteLeadId(
                                                                  val.id
                                                                );
                                                                setShowLeadDeleteModal(
                                                                  true
                                                                );
                                                              }}
                                                            >
                                                              {" "}
                                                              Delete{" "}
                                                            </Dropdown.Item>
                                                          </Dropdown.Menu>
                                                        </Dropdown>
                                                      </div>
                                                    </td>
                                                  </tr>
                                                );
                                              }
                                            )
                                          )
                                        :
                                        <td colSpan={10}  >
                                          <UnauthorizedTableState tabName={"Leads"} />
                                        </td>
                                    }
                                  </tbody>
                                </table>
                              </div>
                            </Tab.Pane>
                            <Tab.Pane
                              eventKey="Locations"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            ></Tab.Pane>
                            <Tab.Pane
                              eventKey="Socials"
                              style={{
                                border: "none",
                                animation: "cardEntry 1s ease-out forwards",
                              }}
                            ></Tab.Pane>
                          </Tab.Content>
                        </Tab.Container>
                      )}
                    </Col>
                  </Row>
                  <Row className="w-100 ms-0 ps-0 pe-2 mt-2 mb-2 contactDetailOffcanvas">
                    <Col
                      md={12}
                      className="tab-container bg-white ps-0 pe-0"
                      style={styles.tabContainer}
                    >
                      <Tab.Container defaultActiveKey="products">
                        <Nav
                          variant="pills"
                          className="nav-style-1 mb-0 d-flex flex-nowrap "
                        >
                          <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                          >
                            <Nav.Link
                              eventKey="products"
                              style={styles.navLinksStyle}
                            >
                              Communication
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                          >
                            <Nav.Link
                              eventKey="cart"
                              style={styles.navLinksStyle}
                            >
                              Location
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                          >
                            <Nav.Link
                              eventKey="orders"
                              style={styles.navLinksStyle}
                            >
                              Social
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item
                            className="me-0"
                            style={{ minWidth: "17%" }}
                          >
                            <Nav.Link
                              eventKey="offers"
                              style={styles.navLinksStyle}
                            >
                              Professional
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item
                            className="me-0"
                            style={{ minWidth: "22%" }}
                          >
                            <Nav.Link
                              eventKey="Campaign"
                              style={styles.navLinksStyle}
                            >
                              Internal
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item
                            className="me-0"
                            style={{
                              width: "-webkit-fill-available",
                              borderBottom: "1px solid #E0E4F8",
                            }}
                          ></Nav.Item>
                        </Nav>

                        <Tab.Content>
                          <Tab.Pane
                            eventKey="products"
                            style={{
                              border: "none",
                              animation: "cardEntry 1s ease-out forwards",
                            }}
                          >
                            <Row className="w-100 ms-0 mb-0 mt-3 ">
                              <Col
                                md={4}
                                className="mb-4 d-flex align-items-start "
                              >
                                <FontAwesomeIcon
                                  icon={faEnvelope}
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "1px",
                                  }}
                                  className=" fs-16"
                                />
                                <div className="w-100">
                                  <p className="mb-0" style={styles.labels}>
                                    Emails
                                  </p>

                                  <div
                                    style={{
                                      fontSize: "14px",
                                      color: "#333",
                                    }}
                                  >
                                    {parsedUserEmail?.[0] ? (
                                      <>
                                        <span
                                          style={{
                                            display: "inline-block",
                                            maxWidth: "250px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            verticalAlign: "middle",
                                          }}
                                          title={parsedUserEmail[0].email} // tooltip on hover
                                        >
                                          <span
                                            className=" d-inline-block"
                                            style={{
                                              // display:"inline-block !important",
                                              width: "70px",
                                              minWidth: "60px",
                                            }}
                                          >
                                            {parsedUserEmail[0].email_type}
                                          </span>
                                          {/* {parsedUserEmail?.[0].email_type ===
                                            "Office"
                                              ? "\u00A0\u00A0\u00A0\u00A0\u00A0"
                                              : " "} */}
                                          : {parsedUserEmail[0].email}
                                        </span>
                                        <br />
                                        {parsedUserEmail.length > 1 &&
                                          !showAllEmails && (
                                            <span
                                              style={{
                                                color: "#0d6efd",
                                                cursor: "pointer",
                                                // marginLeft: "8px",
                                                fontSize: "13px",
                                              }}
                                              onClick={() =>
                                                setShowAllEmails(true)
                                              }
                                            >
                                              +{parsedUserEmail.length - 1} more
                                            </span>
                                          )}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </div>

                                  {/* Expanded emails */}
                                  {showAllEmails && (
                                    <div
                                      style={{
                                        marginTop: "6px",
                                        fontSize: "14px",
                                        color: "#333",
                                        transition: "all 0.3s ease",
                                      }}
                                    >
                                      {parsedUserEmail
                                        .slice(1)
                                        .map((allEmails, index) => (
                                          <div
                                            key={index}
                                            style={{
                                              marginBottom: "4px",
                                              display: "inline-block",
                                              maxWidth: "250px", // adjust as needed
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              verticalAlign: "middle",
                                              // border:"1px solid black"
                                            }}
                                            title={allEmails.email} // tooltip
                                          >
                                            <span
                                              className=" d-inline-block"
                                              style={{
                                                // display:"inline-block !important",
                                                width: "70px",
                                                minWidth: "60px",
                                              }}
                                            >
                                              {allEmails.email_type}
                                              {/* {allEmails?.email_type ===
                                                "Office"
                                                  ? "\u00A0\u00A0\u00A0\u00A0\u00A0"
                                                  : " "} */}
                                            </span>
                                            : {allEmails.email}
                                          </div>
                                        ))}
                                      <br />
                                      <span
                                        style={{
                                          color: "#0d6efd",
                                          cursor: "pointer",
                                          fontSize: "13px",
                                        }}
                                        onClick={() => setShowAllEmails(false)}
                                      >
                                        Show less
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </Col>

                              <Col
                                md={4}
                                className="mb-4 d-flex align-items-start  "
                                style={{ marginLeft: "80px" }}
                              >
                                <FontAwesomeIcon
                                  icon={faPhone}
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "1px",
                                  }}
                                  className=" fs-16"
                                />
                                <div className="w-100">
                                  <p className="mb-0" style={styles.labels}>
                                    Contacts
                                  </p>

                                  <div
                                    style={{
                                      fontSize: "14px",
                                      color: "#333",
                                    }}
                                  >
                                    {parsedUserPhone?.[0] ? (
                                      <>
                                        <span
                                          style={{
                                            display: "inline-block",
                                            maxWidth: "250px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            verticalAlign: "middle",
                                            letterSpacing: "0.25px"
                                          }}
                                          title={`${parsedUserPhone[0].phone_type} + ${parsedUserPhone[0].country_code} ${parsedUserPhone[0].phone}`} // full tooltip
                                        >
                                          <span
                                            className=" d-inline-block"
                                            style={{
                                              // display:"inline-block !important",
                                              width: "60px",
                                              minWidth: "50px",
                                            }}
                                          >
                                            {parsedUserPhone[0].phone_type}
                                          </span>

                                          : {parsedUserPhone[0].country_code}{" "}
                                          {parsedUserPhone[0].phone}
                                        </span>

                                        <br />
                                        {parsedUserPhone.length > 1 &&
                                          !showAllPhoneNumbers && (
                                            <span
                                              style={{
                                                color: "#0d6efd",
                                                cursor: "pointer",
                                                // marginLeft: "8px",
                                                fontSize: "13px",
                                              }}
                                              onClick={() =>
                                                setShowAllPhoneNumbers(true)
                                              }
                                            >
                                              +{parsedUserPhone.length - 1} more
                                            </span>
                                          )}
                                      </>
                                    ) : (
                                      "-"
                                    )}
                                  </div>

                                  {/* Expanded contacts */}
                                  {showAllPhoneNumbers && (
                                    <div
                                      style={{
                                        marginTop: "6px",
                                        fontSize: "14px",
                                        color: "#333",
                                        transition: "all 0.3s ease",
                                      }}
                                    >
                                      {parsedUserPhone
                                        .slice(1)
                                        .map((allPhones, index) => (
                                          <div
                                            key={index}
                                            style={{
                                              marginBottom: "4px",
                                              display: "inline-block",
                                              maxWidth: "250px",
                                              whiteSpace: "nowrap",
                                              overflow: "hidden",
                                              textOverflow: "ellipsis",
                                              verticalAlign: "middle",
                                            }}
                                            title={`${allPhones.phone_type} + ${allPhones.country_code} ${allPhones.phone}`} // tooltip
                                          >
                                            <span
                                              className=" d-inline-block"
                                              style={{
                                                // display:"inline-block !important",
                                                width: "60px",
                                                minWidth: "50px",
                                              }}
                                            >
                                              {allPhones?.phone_type}
                                            </span>

                                            : +{allPhones.country_code}{" "}
                                            {allPhones.phone}
                                          </div>
                                        ))}
                                      <br />
                                      <span
                                        style={{
                                          color: "#0d6efd",
                                          cursor: "pointer",
                                          fontSize: "13px",
                                        }}
                                        onClick={() =>
                                          setShowAllPhoneNumbers(false)
                                        }
                                      >
                                        Show less
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </Col>
                              <Col
                                md={6}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faClock}
                                  className=" fs-16"
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "1px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    TimeZone
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].timezone
                                      ? company_timezone.label
                                      : "-"}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </Tab.Pane>
                          <Tab.Pane
                            eventKey="cart"
                            style={{
                              border: "none",
                              animation: "cardEntry 1s ease-out forwards",
                            }}
                          >
                            <Row className="w-100 ms-0 mb-4 mt-3">
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faFlag}
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                  className=" fs-16"
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Country
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].country_name || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faBuildingColumns}
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                  className=" fs-16"
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    State
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].state_name || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faLocationCrosshairs}
                                  className=" fs-16"
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    City
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].city_name || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faLocationDot}
                                  className=" fs-16"
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Address
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].address || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faMapLocationDot}
                                  className=" fs-16"
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Zip Code
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].zipcode || "-"}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </Tab.Pane>
                          <Tab.Pane
                            eventKey="orders"
                            style={{
                              border: "none",
                              animation: "cardEntry 1s ease-out forwards",
                            }}
                          >
                            <Row className="w-100 ms-0 mb-3 mt-3">
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FaFacebook
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                  className=" fs-16"
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Facebook
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].facebook || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FaLinkedin
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                  className=" fs-16"
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Linkedin
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].linkedin || "-"}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-4 mt-0">
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FaInstagramSquare
                                  className=" fs-16"
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Instagram
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].instagram || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FaTwitterSquare
                                  className=" fs-16"
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Twitter
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].twitter || "-"}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </Tab.Pane>
                          <Tab.Pane
                            eventKey="offers"
                            style={{
                              border: "none",
                              animation: "cardEntry 1s ease-out forwards",
                            }}
                          >
                            <Row className="w-100 ms-0 mb-3 mt-3">
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faLandmarkDome}
                                  style={{
                                    fontSize: "18px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                  className=" fs-16"
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Company
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].company_name || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faBriefcase}
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                  className=" fs-16"
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Business Type
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].business_type || "-"}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                            <Row className="w-100 ms-0 mb-3 mt-0">
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faAddressBook}
                                  className=" fs-16"
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Industry
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].industry || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faPenFancy}
                                  className=" fs-16"
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Employee Size
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].employee_size || "-"}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </Tab.Pane>
                          <Tab.Pane
                            eventKey="Campaign"
                            style={{
                              border: "none",
                              animation: "cardEntry 1s ease-out forwards",
                            }}
                          >
                            <Row className="w-100 ms-0 mb-4 mt-3">
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faEnvelope}
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                  className=" fs-16"
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Created By
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].added_name || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faPhone}
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                  className=" fs-16"
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Created At
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].created_at
                                      ? new Date(
                                        companyData[0].created_at
                                      ).toLocaleDateString()
                                      : "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faLocationDot}
                                  className=" fs-16"
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Modified by
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].updater_name || "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faLocationDot}
                                  className=" fs-16"
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Modified At
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].updated_at
                                      ? new Date(
                                        companyData[0].updated_at
                                      ).toLocaleDateString()
                                      : "-"}
                                  </p>
                                </div>
                              </Col>
                              <Col
                                md={4}
                                className="mb-3 d-flex align-items-start"
                              >
                                <FontAwesomeIcon
                                  icon={faLocationDot}
                                  className=" fs-16"
                                  style={{
                                    fontSize: "16px",
                                    marginRight: "13px",
                                    color: "#2656a8",
                                    marginTop: "6px",
                                  }}
                                />
                                <div>
                                  <p className="mb-0" style={styles.labels}>
                                    Lead Owner
                                  </p>
                                  <p className="mb-0" style={styles.values}>
                                    {companyData[0].owner_name || "-"}
                                  </p>
                                </div>
                              </Col>
                            </Row>
                          </Tab.Pane>
                        </Tab.Content>
                      </Tab.Container>
                    </Col>
                  </Row>
                </Col>
                <Col
                  md={4}
                  style={{ height: "96%", borderLeft: "1px solid #d1d4e3" }}
                  className="pt-0"
                >
                  <div className="card h-100 cardBorders">
                    <Accordion
                      allowZeroExpanded
                      preExpanded={["contacts"]}
                      style={{
                        overflow: "auto",
                        paddingBottom: 9,
                        height: "99.4%",
                      }}
                    >
                      {/* Contacts (Always Open Initially) */}
                      <AccordionItem
                        uuid="contacts"
                        style={styles.accordion__item}
                      >
                        <AccordionItemHeading style={styles.accordion__heading}>
                          <AccordionItemState>
                            {({ expanded }) => (
                              <AccordionItemButton
                                className="accordion__button"
                                style={styles.accordion__button}
                              >
                                <h5
                                  className="accordion__title"
                                  style={styles.accordion__title}
                                >
                                  <FontAwesomeIcon
                                    icon={faUser}
                                    style={{
                                      fontSize: "13px",
                                      color: "#536485",
                                      width: "16px",
                                    }}
                                  />
                                  Contacts
                                </h5>
                                <FontAwesomeIcon
                                  icon={expanded ? faAngleUp : faAngleDown}
                                  style={{ transition: "transform 0.3s ease" }}
                                />
                              </AccordionItemButton>
                            )}
                          </AccordionItemState>
                        </AccordionItemHeading>
                        <AccordionItemPanel
                          className="accordion__panel"
                          style={styles.accordion__panel}
                        >
                          {
                            contactGrants?.isView ?
                              companyData[0].contact_list.length > 0 ? (
                                companyData[0].contact_list.map((item) => {
                                  const contact_phone = JSON.parse(item.user_phone);
                                  return (
                                    <div
                                      style={{
                                        ...styles.contactDetails,
                                        cursor: "pointer",
                                      }}
                                      onClick={() => {
                                        setSelectedContactId(item.id);
                                        setShowContactDetails(true);
                                      }}
                                      key={item.id}
                                    >
                                      <div
                                        className="rounded-circle overflow-hidden border border-0 d-flex justify-content-center align-items-center"
                                        style={{
                                          ...styles.roundedIcons,
                                          backgroundColor: getRandomColor(item.id), // Use function here
                                        }}
                                      >
                                        {
                                          (item.first_name + item.last_name)
                                            .substring(0, 2)
                                            .toUpperCase()
                                        }
                                      </div>
                                      <div>
                                        <p className="mb-0 d-flex align-items-baseline">
                                          {item.first_name + " " + item.last_name}
                                          <h6 style={styles.departmentName}>
                                            - {item.designation}
                                          </h6>
                                        </p>
                                        <p
                                          className="mb-0 fs-11"
                                          style={styles.departmentEmails}
                                        >
                                          <span>
                                            <FontAwesomeIcon
                                              icon={faEnvelope}
                                              className="fs-10 me-1"
                                            />{" "}
                                            {item?.email || "-"}
                                          </span>
                                          <span className="ms-2">
                                            <FontAwesomeIcon
                                              icon={faPhoneVolume}
                                              className="fs-10 me-1"
                                            />
                                            {"+" +
                                              contact_phone?.[0]?.country_code +
                                              " " +
                                              contact_phone?.[0]?.phone || "-"}
                                          </span>
                                        </p>
                                      </div>
                                    </div>
                                  );
                                })
                              ) : (
                                <div
                                  class="d-flex justify-content-center align-items-center"
                                  style={{ position: "absolute", left: "26%", top: "25%" }}
                                >
                                  <img
                                    src={nodata}
                                    alt=""
                                    style={{ width: "15rem", marginTop: "0" }}
                                  />
                                </div>
                              )
                              :
                              <UnauthViewModal tabName={"Contact"} />
                          }
                        </AccordionItemPanel>
                      </AccordionItem>

                      {/* Notes */}

                      <AccordionItem
                        uuid="notes"
                        style={styles.accordion__item}
                      >
                        <AccordionItemHeading style={styles.accordion__heading}>
                          <AccordionItemState>
                            {({ expanded }) => (
                              <AccordionItemButton
                                className="accordion__button"
                                style={styles.accordion__button}
                              >
                                <h5
                                  className="accordion__title"
                                  style={styles.accordion__title}
                                >
                                  <FontAwesomeIcon
                                    icon={faStickyNote}
                                    style={{
                                      fontSize: "13px",
                                      color: "#536485",
                                      width: "16px",
                                    }}
                                  />
                                  Notes
                                </h5>
                                <FontAwesomeIcon
                                  icon={expanded ? faAngleUp : faAngleDown}
                                  style={{ transition: "transform 0.3s ease" }}
                                />
                              </AccordionItemButton>
                            )}
                          </AccordionItemState>
                        </AccordionItemHeading>

                        <AccordionItemPanel
                          className="accordion__panel"
                          style={styles.accordion__panel}
                        >
                          <div
                            className="listStyleForContact"
                            style={{
                              minHeight: "33rem",
                              height: "23rem",

                              overflowX: "auto",
                            }}
                          >
                            {isNotesLoading && !notesContent ? (
                              <div className="text-center py-4">
                                Loading notes...
                              </div>
                            ) : (
                              <>
                                {/* Editor when add/update note */}
                                {(!isNotesOpen || editingNoteId) && (
                                  <>
                                    <div
                                      className="mb-3 p-2"
                                      style={{
                                        animation:
                                          "cardEntry 1s ease-out forwards",
                                      }}
                                    >
                                      {/* <CKEditor
                                        editor={ClassicEditor}
                                        data={notesContent}
                                        onChange={(event, editor) => {
                                          const data = editor.getData();
                                          setNotesContent(data);
                                        }}
                                        onReady={(editor) => {
  editor.editing.view.change((writer) => {
    writer.setStyle(
      "min-height",
      "100px", 
      editor.editing.view.document.getRoot()
    );
  });
}}

                                        config={{
                                          toolbar: [
                                            "heading",
                                            "|",
                                            "bold",
                                            "italic",
                                            "link",
                                            "bulletedList",
                                            "numberedList",
                                            "|",
                                            "outdent",
                                            "indent",
                                            "|",
                                            "blockQuote",
                                            "undo",
                                            "redo",
                                          ],
                                        }}
                                      /> */}

                                      <ReactQuill
                                        theme="snow"
                                        value={notesContent}
                                        onChange={(value) =>
                                          setNotesContent(value)
                                        }
                                        placeholder="Write your message..."
                                        style={{ minHeight: "160px" }}
                                        modules={{
                                          toolbar: [
                                            [{ header: [1, 2, false] }],
                                            [
                                              "bold",
                                              "italic",
                                              "underline",
                                              "link",
                                            ],
                                            [
                                              { list: "ordered" },
                                              { list: "bullet" },
                                            ],
                                            ["blockquote", "code-block"],
                                            ["clean"],
                                          ],
                                        }}
                                      />
                                    </div>

                                    {notesError && (
                                      <p className="text-danger mt-0 mb-0 fs-12">
                                        {notesError}
                                      </p>
                                    )}

                                    <div className="d-flex justify-content-end gap-2 mb-2 pe-2">
                                      <button
                                        className="btn btn-default-outline"
                                        style={{ fontSize: 13 }}
                                        onClick={() => {
                                          setNotesContent("");
                                          setEditingNoteId(null);
                                          setIsNotesOpen(true); // go back to list
                                        }}
                                        disabled={isNotesLoading}
                                      >
                                        Cancel
                                      </button>
                                      <button
                                        className="btn btn-default"
                                        style={{ fontSize: 13 }}
                                        onClick={() => {
                                          handleSaveNote();
                                          setIsNotesOpen(true); // hide editor after save
                                        }}
                                        disabled={isNotesLoading}
                                      >
                                        {isNotesLoading
                                          ? "Saving..."
                                          : editingNoteId
                                            ? "Update"
                                            : "Save"}
                                      </button>
                                    </div>
                                  </>
                                )}

                                {/* Notes List */}
                                {loadings && (
                                  <div
                                    style={{
                                      position: "absolute",
                                      top: 0,
                                      left: 0,
                                      right: 0,
                                      bottom: 0,
                                      backgroundColor: "rgba(255, 255, 255, 0.8)",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      zIndex: 1000,
                                      borderRadius: "inherit",
                                    }}
                                  >
                                    <div className="d-flex flex-column align-items-center">
                                      <div
                                        className="spinner-border text-primary"
                                        role="status"
                                        style={{ width: "3rem", height: "3rem" }}
                                      >
                                        <span className="visually-hidden">Loading...</span>
                                      </div>
                                      {/* <div className="mt-2 text-primary fw-semibold">
                                        Form Submitting..
                                      </div> */}
                                    </div>
                                  </div>
                                )}
                                <div className="notes-list p-3 px-1">
                                  <div className="d-flex px-3 align-items-center justify-content-between">
                                    <p>Previous Notes : </p>

                                    {/*  Add button will always show when isNotesOpen is true */}
                                    {isNotesOpen && (
                                      <button
                                        className="btn btn-default-outline"
                                        style={styles.buttons}
                                        onClick={() => {
                                          if (!companyNoteGrant.isCreate) {
                                            toast.warning("You are not authorized for this action!")
                                            return
                                          }
                                          setIsNotesOpen(false); // show editor when Add is clicked
                                          setNotesContent("");
                                          setEditingNoteId(null);
                                        }}
                                        disabled={isNotesLoading}
                                      >
                                        {isNotesLoading ? (
                                          <span
                                            className="spinner-border spinner-border-sm"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          <>
                                            <FontAwesomeIcon icon={faPlus} />{" "}
                                            Add
                                          </>
                                        )}
                                      </button>
                                    )}
                                  </div>

                                  {
                                    companyNoteGrant.isView ?
                                      notes.length > 0 ? (
                                        notes.map((note) => {
                                          const text =
                                            note.notes +
                                            '<span style="display:inline"></span>';

                                          const cleanHTML = text;

                                          const wordLimit = 20;
                                          const words = cleanHTML.split(" ");
                                          const isExpanded =
                                            expandedNoteId === note.id;
                                          const shouldShowButton =
                                            words.length > wordLimit;

                                          const displayedText = isExpanded
                                            ? cleanHTML
                                            : words.slice(0, wordLimit).join(" ");

                                          const inlineHtml =
                                            forceInline(displayedText);

                                          return (
                                            <div
                                              key={note.id}
                                              className="p-3 border-bottom"
                                            >
                                              <div className="d-flex justify-content-between align-items-start">
                                                {/* Note Text */}
                                                <div
                                                  style={{
                                                    display: "flex",
                                                    fontSize: 14,
                                                    color: "black",
                                                  }}
                                                >
                                                  <FaStickyNote
                                                    size={18}
                                                    style={{
                                                      minWidth: 18,
                                                      marginRight: 10,
                                                      marginTop: 4,
                                                    }}
                                                  />
                                                  <span
                                                    style={{ display: "inline" }}
                                                  >
                                                    <span
                                                      dangerouslySetInnerHTML={{
                                                        __html: inlineHtml,
                                                      }}
                                                      style={{ display: "inline" }}
                                                    />{" "}
                                                    {shouldShowButton && (
                                                      <span
                                                        onClick={() =>
                                                          setExpandedNoteId(
                                                            isExpanded
                                                              ? null
                                                              : note.id
                                                          )
                                                        }
                                                        style={{
                                                          color: "blue",
                                                          cursor: "pointer",
                                                          display: "inline",
                                                        }}
                                                      >
                                                        {isExpanded
                                                          ? "...less"
                                                          : "...more"}
                                                      </span>
                                                    )}
                                                  </span>
                                                </div>

                                                {/* Dropdown */}
                                                <Dropdown className="dropdropdownsWithoutToggle">
                                                  <Dropdown.Toggle
                                                    variant="none"
                                                    id={`dropdown - note - ${note.id}`}
                                                    style={{
                                                      border: "none",
                                                      background: "none",
                                                    }}
                                                    className="dropdownTogglesBtns ms-3 p-0"
                                                  >
                                                    <FontAwesomeIcon
                                                      icon={faEllipsisVertical}
                                                      style={{ color: "black" }}
                                                    />
                                                  </Dropdown.Toggle>
                                                  <Dropdown.Menu>
                                                    <Dropdown.Item
                                                      onClick={() => {
                                                        if (!companyNoteGrant.isEdit) {
                                                          toast.warning("You are not authorized for this action!")
                                                          return
                                                        }
                                                        handleEditNote(note.id)
                                                      }
                                                      }
                                                    >
                                                      Edit
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                      onClick={() => {
                                                        if (!companyNoteGrant.isDelete) {
                                                          toast.warning("You are not authorized for this action!")
                                                          return
                                                        }
                                                        setNoteToDelete(note);
                                                        setShowDeleteModal(true);
                                                      }}
                                                    >
                                                      Delete
                                                    </Dropdown.Item>
                                                  </Dropdown.Menu>
                                                </Dropdown>
                                              </div>

                                              {/* Footer with user + date */}
                                              <p
                                                className="mb-0 mt-3 d-flex justify-content-between"
                                                style={{
                                                  fontWeight: 300,
                                                  fontSize: 12,
                                                  color: "#aeaeae",
                                                }}
                                              >
                                                {note.added_name}
                                                <span>
                                                  {formatDateInAlphabeticalMonth(
                                                    note.created_at
                                                  )}{" "}
                                                  | at {formatTime(note.created_at)}
                                                </span>
                                              </p>
                                            </div>
                                          );
                                        })
                                      ) : (
                                        <div
                                          class="d-flex justify-content-center align-items-center"
                                          style={{ position: "absolute", left: "16%" }}
                                        >
                                          <img
                                            src={nodata}
                                            alt=""
                                            style={{ width: "15rem", marginTop: "0" }}
                                          />
                                        </div>
                                      )
                                      :
                                      <UnauthViewModal tabName={"Notes"} />
                                  }
                                </div>
                              </>
                            )}
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>

                      {/* Activities */}
                      <AccordionItem
                        uuid="activities"
                        style={styles.accordion__item}
                      >
                        <AccordionItemHeading style={styles.accordion__heading}>
                          <AccordionItemState>
                            {({ expanded }) => (
                              <AccordionItemButton
                                className="accordion__button"
                                style={styles.accordion__button}
                              >
                                <h5
                                  className="accordion__title"
                                  style={styles.accordion__title}
                                >
                                  <FontAwesomeIcon
                                    icon={faList}
                                    style={{
                                      fontSize: "13px",
                                      color: "#536485",
                                      width: "16px",
                                    }}
                                  />
                                  Activities
                                </h5>
                                <FontAwesomeIcon
                                  icon={expanded ? faAngleUp : faAngleDown}
                                  style={{ transition: "transform 0.3s ease" }}
                                />
                              </AccordionItemButton>
                            )}
                          </AccordionItemState>
                        </AccordionItemHeading>
                        <AccordionItemPanel
                          className="accordion__panel"
                          style={styles.accordion__panel}
                        >
                          <ContactActivity module_id={companyId} module_name={"company"} headers={headers} extras={extras} />
                        </AccordionItemPanel>
                      </AccordionItem>
                      {/* Quotations */}
                      <AccordionItem
                        uuid="quotations"
                        style={{ borderRadius: "0px" }}
                      >
                        <AccordionItemHeading style={styles.accordion__heading}>
                          <AccordionItemState>
                            {({ expanded }) => (
                              <AccordionItemButton
                                className="accordion__button"
                                style={styles.accordion__button}
                              >
                                <h5
                                  className="accordion__title"
                                  style={styles.accordion__title}
                                >
                                  <FontAwesomeIcon
                                    icon={faFileLines}
                                    style={{
                                      fontSize: "13px",
                                      color: "#536485",
                                      width: "16px",
                                    }}
                                  />
                                  Documents
                                </h5>
                                <FontAwesomeIcon
                                  icon={expanded ? faAngleUp : faAngleDown}
                                  style={{ transition: "transform 0.3s ease" }}
                                />
                              </AccordionItemButton>
                            )}
                          </AccordionItemState>
                        </AccordionItemHeading>
                        <AccordionItemPanel
                          className="accordion__panel"
                          style={styles.accordion__panel}
                        >
                          <div
                            className="listStyleForContact"
                            style={{
                              minHeight: "33rem",
                              height: "23rem",
                              overflowX: "auto",
                            }}
                          >
                            <DocumentsList
                              onDelete={onDelete}
                              documentData={documentData}
                              // setDocumentData={setDocumentData}
                              setDeleteDocument={setDeleteDocument}
                              documents={documents}
                              fetchDocument={fetchDocument}
                              setDocuments={setDocuments}
                              setDocumentToDelete={setDocumentToDelete}
                              documentToDelete={documentToDelete}
                              id={companyId}
                              moduleType="Company"
                              show={show}
                              docGrant={companyDocGrant}
                            />
                          </div>
                        </AccordionItemPanel>
                      </AccordionItem>
                    </Accordion>
                  </div>
                </Col>
              </Row>
            </div >
          </Offcanvas.Body >
        </Offcanvas >
        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={() => handleDeleteNote(noteToDelete)}
          note={noteToDelete}
          isLoading={loading}
          message="Are you want delete note?"
        />

        {/* Integration Error Modal (for failures) */}
        <Modal
          show={showMessageModal.sms}
          onHide={() =>
            setShowMessageModal((prev) => ({ ...prev, sms: false }))
          }
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Send SMS</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="mb-3">
              <label className="form-label">Message</label>
              <textarea
                className="form-control"
                name="body"
                value={messageData.body}
                onChange={handleMessageInputChange}
                placeholder="Enter your message..."
                rows="5"
              />
            </div>

            <div className="mb-3">
              <label className="form-label">Notes (Optional)</label>
              <textarea
                className="form-control"
                name="notes"
                value={messageData.notes}
                onChange={handleMessageInputChange}
                placeholder="Add any notes..."
                rows="2"
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-default-outline"
              onClick={() =>
                setShowMessageModal((prev) => ({ ...prev, sms: false }))
              }
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-default"
              onClick={() => handleSendMessage("sms")}
            >
              Send SMS
            </button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={showEmailModal}
          onHide={handleCloseEmailModal}
          centered
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title className="d-flex justify-content-between align-items-center w-100">
              <span>Send Email</span>
              <div className="d-flex align-items-center gap-2">
                <span style={{ fontSize: "14px", fontWeight: "normal" }}>
                  Choose Template:
                </span>
                <Dropdown>
                  <Dropdown.Toggle
                    variant="outline-primary"
                    size="sm"
                    disabled={templatesLoading}
                  >
                    {templatesLoading
                      ? "Loading..."
                      : selectedTemplate || "Select Template"}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={() => handleTemplateSelect("", "")}>
                      No Template
                    </Dropdown.Item>
                    {templates.map((template) => (
                      <Dropdown.Item
                        key={template.id}
                        onClick={() =>
                          handleTemplateSelect(
                            template.id,
                            template.template_name
                          )
                        }
                      >
                        {template.template_name}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {/* To Field with Tag Input */}
            <div className="mb-3">
              <label className="form-label">To</label>
              <div className="border rounded p-2" style={{ minHeight: "45px" }}>
                <div className="d-flex flex-wrap gap-1 align-items-center">
                  {emailRecipients.map((email, index) => (
                    <span
                      key={index}
                      className="badge bg-primary d-flex align-items-center gap-1"
                      style={{ fontSize: "12px" }}
                    >
                      {email}
                      <FontAwesomeIcon
                        icon={faTimes}
                        style={{ cursor: "pointer", fontSize: "10px" }}
                        onClick={() => removeEmailTag(email)}
                      />
                    </span>
                  ))}
                  <input
                    type="email"
                    className="border-0 flex-grow-1"
                    style={{ outline: "none", minWidth: "200px" }}
                    placeholder="Press ENTER to add email..."
                    value={currentEmailInput}
                    onChange={(e) => setCurrentEmailInput(e.target.value)}
                    onKeyDown={handleEmailInputKeyDown}
                    onBlur={addEmailTag}
                  />
                </div>
              </div>
            </div>

            {/* Subject Field */}
            <div className="mb-3">
              <label className="form-label">Subject</label>
              <input
                type="text"
                className="form-control"
                name="subject"
                value={messageData.subject}
                onChange={handleMessageInputChange}
                placeholder="Enter email subject"
              />
            </div>

            {/* Body Field with CKEditor */}
            <div className="mb-3">
              <label className="form-label fw-bold mb-2">Body</label>
              <div className="ckeditor-container">

                <ReactQuill
                  theme="snow"
                  value={messageData.body}
                  onChange={handleBodyChange}
                  placeholder="Write your message..."
                  style={{ minHeight: "160px" }}
                  modules={{
                    toolbar: [
                      [{ header: [1, 2, false] }],
                      ["bold", "italic", "underline", "link"],
                      [{ list: "ordered" }, { list: "bullet" }],
                      ["blockquote", "code-block"],
                      ["clean"],
                    ],
                  }}
                />
              </div>
            </div>

            {/* Attachment Field */}
            <div className="mb-3">
              <label className="form-label">Attachment</label>
              <input
                type="file"
                className="form-control"
                onChange={handleFileChange}
                accept=".pdf,.doc,.docx,.txt,.jpg,.jpeg,.png"
              />
            </div>

            {/* Syntax Notes Table */}
            <div className="col-md-12 mt-4">
              <h3 className="h5 mb-2">Available Syntax</h3>
              <Table bordered size="sm">
                <thead>
                  <tr>
                    <th>SYNTAX</th>
                    <th>FIELD</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{"{{to_contact_name}}"}</td>
                    <td>Recipient Contact Name</td>
                  </tr>
                  <tr>
                    <td>{"{{to_company_name}}"}</td>
                    <td>Recipient Company Name</td>
                  </tr>
                  <tr>
                    <td>{"{{sender_name}}"}</td>
                    <td>Sender Name</td>
                  </tr>
                  <tr>
                    <td>{"{{sender_company_name}}"}</td>
                    <td>Sender Company Name</td>
                  </tr>
                  <tr>
                    <td>{"{{sender_number}}"}</td>
                    <td>Sender Phone Number</td>
                  </tr>
                  <tr>
                    <td>{"{{sender_email}}"}</td>
                    <td>Sender Email Address</td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-default-outline"
              onClick={handleCloseEmailModal}
              disabled={emailSending}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-default"
              onClick={handleSendEmail}
              disabled={emailSending || emailRecipients.length === 0}
            >
              {emailSending ? "Sending..." : "Send Email"}
            </button>
          </Modal.Footer>
        </Modal>

        {/* Integration Error Modal */}
        <Modal
          show={
            showIntegrationModal.whatsapp ||
            showIntegrationModal.sms ||
            showIntegrationModal.email
          }
          onHide={() =>
            setShowIntegrationModal({
              whatsapp: false,
              sms: false,
              email: false,
            })
          }
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {showIntegrationModal.whatsapp && "WhatsApp Integration Required"}
              {showIntegrationModal.sms && "SMS Integration Required"}
              {showIntegrationModal.email && "Email Integration Required"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <div className="mb-3">
              {showIntegrationModal.whatsapp && (
                <i
                  className="fab fa-whatsapp text-success"
                  style={{ fontSize: "48px" }}
                ></i>
              )}
              {showIntegrationModal.sms && (
                <i
                  className="fas fa-sms text-info"
                  style={{ fontSize: "48px" }}
                ></i>
              )}
              {showIntegrationModal.email && (
                <i
                  className="fas fa-envelope text-primary"
                  style={{ fontSize: "48px" }}
                ></i>
              )}
            </div>
            {showIntegrationModal.whatsapp && (
              <>
                <h5>WhatsApp Integration Not Configured</h5>
                <p className="mb-3">
                  {integrationError.whatsapp ||
                    "WhatsApp Business API is not configured. Please contact your administrator."}
                </p>
              </>
            )}

            {showIntegrationModal.sms && (
              <>
                <h5>SMS Integration Not Configured</h5>
                <p className="mb-3">
                  {integrationError.sms ||
                    "SMS gateway is not configured. Please contact your administrator."}
                </p>
              </>
            )}

            {showIntegrationModal.email && (
              <>
                <h5>Email Integration Not Configured</h5>
                <p className="mb-3">
                  {integrationError.email ||
                    "SMTP settings are not configured. Please contact your administrator."}
                </p>
              </>
            )}

            <button
              className="btn btn-primary mb-2"
              onClick={() => {
                if (!extras?.navigate) return;

                const path =
                  integrationError.whatsapp || integrationError.sms
                    ? "/integration/msg91"
                    : integrationError.email
                      ? "/integration/email"
                      : null;

                if (path) extras.navigate(path);
                setShowIntegrationModal({
                  whatsapp: false,
                  sms: false,
                  email: false,
                });
              }}
            >
              Go to Integration Settings
            </button>
          </Modal.Body>
          <Modal.Footer>
            <button
              type="button"
              className="btn btn-secondary"
              onClick={() =>
                setShowIntegrationModal({
                  whatsapp: false,
                  sms: false,
                  email: false,
                })
              }
            >
              Close
            </button>
          </Modal.Footer>
        </Modal>
      </div >
      {/* Add this right before the closing </div> of your main return */}
      {
        selectedContactId !== null && (
          <ContactDetails
            show={showContactDetails}
            onCanvasClose={() => setShowContactDetails(false)}
            id={selectedContactId}
            allContacts={companyData[0]?.contact_list || []} // Add this line
          />
        )
      }
      {
        whatsappModalOpen && (
          <WhatsappModal
            whatsappModalOpen={whatsappModalOpen}
            setWhatsAppModalOpen={setWhatsAppModalOpen}
            id={companyId}
            module_name={"company"}
          />
        )
      }
      {
        showAddDealOffcanvas && (
          <CreateDeal
            show={showAddDealOffcanvas}
            onHide={() => {
              setShowAddDealOffcanvas(false);
            }}
            moduleName="company"
            onLeadCreated={fetchAllDeals}
            contactArrCompany={companyData[0].contact_list}
          />
        )
      }

      {
        showAddLeadsOffcanvas && (
          <CreateLead
            show={showAddLeadsOffcanvas}
            onHide={() => {
              setShowAddLeadsOffcanvas(false);
              setEditLeadId(null);
            }}
            module_name="company"
            contactArray={companyData[0].contact_list}
            id={companyId}
            onLeadCreated={fetchCompanyDetails}
            onLeadUpdated={fetchCompanyDetails}
            editId={editLeadId}
          />
        )
      }
      <UpdateDeal
        show={showUpdateDealOffcanvas}
        onHide={handleUpdateDealClose}
        editId={editDealId}
        onLeadUpdated={fetchAllDeals}
      />
      {
        showDealDetails && (
          <DealDetails
            show={showDealDetails}
            onClose={handleClose}
            leadId={selectedDealId}
          />
        )
      }
      {
        showLeadDetails && (
          <LeadsDetails
            show={showLeadDetails}
            // setRefetchLeadsData={setRefetchLeadsData}
            onClose={handleClose}
            leadId={selectedLeadId}
          // pipelineStageData={pipelineStages}
          // pipelines={pipelines}
          />
        )

      }
      {/* {twilio modal} */}
      {
        showtwilioModal && (
          <TwilioIntegrationForm isOpen={showtwilioModal} onClose={() => setShowTwilioModal(false)} />
        )
      }
      {/* global */}
      {
        globalDiller && (
          <GlobalCallModal isOpen={globalDiller} customerId={customerId} loginUserId={customer?.customer_details?.id} phoneNumber={`${userPhone.country_code} ${userPhone.phone}`} onClose={handleGlobalCallChange} module_id={companyId} module_name={'company'} />
        )
      }
      {/* delete leads */}
      {
        showLeadDeleteModal && (
          <DeleteModal
            show={setShowLeadDeleteModal}
            onClose={() => {
              setShowLeadDeleteModal(false);
              setDeleteLeadId(null);
            }}
            onConfirm={handleDeleteConfirm}
            isLoading={loading}
            message="Are you sure you want to delete this lead?"
          />
        )
      }

      {/* delete deals */}
      {
        showDealDeleteModal && (
          <DeleteModal
            show={showDealDeleteModal}
            onClose={() => {
              setDeleteDealId(null);
              setShowDealDeleteModal(false);
            }}
            isLoading={loading}
            onConfirm={handleDeleteDealConfirm}
            message="Are you sure you want to delete this lead?"
          />
        )}
      {deleteDocument && (
        <DeleteModal
          show={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={handleConfirmedDelete}
          isLoading={loading}
          message={"Are you sure you want to permanently delete this document?"}
        />
      )}
      {callLogOpen && (
        <DyanmicCallLog
          show={callLogOpen}
          onCloseModal={() => setCallLogOpen(false)}
          module_id={companyId}
          module_name={"company"}
        />
      )}
      {/* {showModal && (
        <EmailSettingsModal
          show={showModal}
          onHide={() => setShowModal(false)}
          mailto="saurabh07mahi@gmail.com"
        />
      )} */}
    </>
  );
};
const styles = {
  bottomP: {
    fontSize: 11,
  },
  bottomH4: {
    marginBottom: 2,
  },
  buttons: {
    color: "#fff",
    fontSize: "13px",
    height: "27px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "-16px",
  },
  filterbuttons: {
    fontSize: "13px",
    height: "34px",
    width: "34px",
    borderRadius: "4px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  ulStyles: {
    display: "flex",
    alignItems: "center",
    gap: "3px",
    justifyContent: "space-between",
    width: "100%",
  },
  listButtonsStyles: {
    fontSize: "13px",
    // borderBottom: '1px solid #e3e3e3',
    height: "30px",
    width: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
    gap: 3,
  },
  navButtonsStyles: {
    fontSize: "15px",
    height: "34px",
    minWidth: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
  },
  iconStyles: {
    fontSize: 13,
    color: "#fff",
  },
  emptyDivs: {
    borderRight: "1px solid #E0E4F8",
    height: "35px",
    margin: "0px 2px",
  },
  DropdownItemsStyle: {
    fontSize: ".93re",
    letterSpacing: ".0386rem",
    fontWeight: 400,
    color: "#2e384d",
  },
  navLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  inActiveNavLinksStyle: {
    borderRadius: "0px",
    borderBottom: "1px solid #E0E4F8",
    borderRight: "1px solid #E0E4F8",
    fontSize: 14,
    padding: "11px",
    fontFamily: '"Inter", sans-serif !important',
    fontWeight: 400,



    lineHeight: 1.5,
    pointerEvents: "none",
  },
  tabContainer: {
    border: "1px solid #E0E4F8",
    borderRadius: "4px",
  },
  stickyHeader: {
    paddingBottom: "11px",
    position: "sticky",
    background: "#fff",
    top: "0px",
  },
  labels: {
    fontSize: "12px",
    color: "#B0BAC9",
    fontWeight: 400,
  },
  iconsStyles: {
    color: "#2656a8",
    border: "1px solid #e6e6e6",
    background: "#e9f1ff",
    padding: "9px",
    borderRadius: "50%",
    marginRight: "10px",
    width: "15px",
    height: "15px",
    fontSize: "13px",
  },
  values: {
    color: "#2e384d",
    fontWeight: 400,
    fontSize: ".8333rem",
    letterSpacing: '0.25px',
  },
  accordion__item: {
    borderRadius: "0px",
    borderBottom: " 1px solid #d7d7d7",
    animation: "cardEntry 1s ease-out forwards",
  },
  accordion__heading: {
    width: "100%",
  },
  accordion__panel: {
    padding: "14px 0px ",
    maxHeight: "35rem",
    overflow: "auto",
    minHeight: "35rem",
    animation: "cardEntry 1s ease-out forwards",
  },
  accordion__button: {
    display: "flex",
    alignItems: "center",
    padding: "13px 20px",
    justifyContent: "space-between",
    background: "#f4f4f4",
  },
  accordion__title: {
    marginBottom: 0,
    fontWeight: 300,
    letterSpacing: "0.0119rem",
    fontSize: "1rem",
    lineHeight: 1,
    display: "flex",
    alignItems: "center",
    gap: "5px",
  },
  contactDetails: {
    display: "flex",
    alignItems: "center",
    gap: "13px",
    padding: "14px 16px ",
    borderBottom: "0.01rem solid #ebebeb",
  },
  roundedIcons: {
    width: "45px",
    height: "45px",
    backgroundColor: "#d5d6e8",
    color: "#2e384d",
  },
  departmentName: {
    color: "#3f97fd",
    fontSize: "13px",
    fontWeight: 400,
    marginLeft: "9px",
    marginBottom: 0,
  },
  departmentEmails: {
    color: "grey",
    fontWeight: 300,
  },
  listButtonsStyless: {
    fontSize: "13px",
    // borderBottom: '1px solid #e3e3e3',
    height: "30px",
    width: "56px",
    gap: 3,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "2px",
    color: "#fff",
  },
};